// IMPORTS
import React, { useState, useEffect, useContext, useRef, useCallback } from "react";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import CardContent from "@mui/material/CardContent";
import { Grid, Stack, Typography, Drawer, Button, Box, TextField, Container, IconButton, CardHeader, Modal } from "@mui/material";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import RenderStatus from "./RenderStatus";
import PdfCanvasPreview from "./PdfCanvasPreview";
import PdfThumbnail from "./PdfThumbnail";
import { IMAGES_URL } from "Utils/URLs";
import { getDisplayUrl } from "Utils/mediaUrl";
import DriveWithUsState from "../Hooks/DriveWithUs.state";
import PartnerWithUsState from "../Hooks/PartnerWithUs.state";
import FreeRideState from "../Hooks/FreeRide.state";
import 'lightbox2/dist/css/lightbox.min.css';
import lightbox from 'lightbox2';
import $ from 'jquery';
import { UserContext } from "Hooks/UserContext";
import { Close } from "@mui/icons-material";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import PaymentComponent from "./PaymentComponent";
import PaymentState from 'Hooks/Payment.state';
import Swal from "sweetalert2";
import { FormFeedback, Input, Spinner } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { FaCloudUploadAlt } from 'react-icons/fa';
import FileUploadField from "./FileUploadField";
const styles = {
  details: {
    padding: "1rem",
    borderTop: "1px solid #e1e1e1"
  },
  value: {
    padding: "1rem 2rem",
    borderTop: "1px solid #e1e1e1",
    color: "#899499"
  }
};

// No longer used (car inspection date can be any future date; backend caps to 4 months)
const getCarInspectionDateLimits = () => ({});

// Date that will actually be saved: if user selects beyond 4 months, show today+4 months (capped)
const getEffectiveCarInspectionExpiryDisplay = (selectedDateStr) => {
  if (!selectedDateStr || !String(selectedDateStr).trim()) return null;
  const s = String(selectedDateStr).trim();
  const d = new Date(s.includes("T") ? s : s + "T12:00:00");
  if (isNaN(d.getTime())) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const max = new Date(today);
  max.setMonth(max.getMonth() + 4);
  max.setHours(23, 59, 59, 999);
  d.setHours(0, 0, 0, 0);
  const effective = d.getTime() > max.getTime() ? max : d;
  const m = effective.getMonth() + 1;
  const day = effective.getDate();
  const y = effective.getFullYear();
  return `${String(m).padStart(2, "0")}/${String(day).padStart(2, "0")}/${y}`;
};

// Car inspection expiry: any future date allowed in UI; backend caps to today+4 months when saving
const validateCarInspectionExpiryDate = (dateStr) => {
  if (!dateStr || !dateStr.trim()) return { valid: true };
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return { valid: false, message: "Invalid date" };
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  d.setHours(0, 0, 0, 0);
  if (d < today) return { valid: false, message: "Car inspection expiry cannot be in the past" };
  return { valid: true };
};



export default function SettingsCard({ value, setValue, driveWithUsData = [], partnerWithUsData = [], freeRideData = [] }) {
  const { formBusy, UpdateDriveWithUs, response, GetDriveWithUs, oldData } = DriveWithUsState()

  const [openDrawer, setOpenDrawer] = useState(false)
  const [openMobileDrawer, setOpenMobileDrawer] = useState(false)
  const [drawerData, setDrawerData] = useState({})
  const [mobiledrawerData, setMobileDrawerData] = useState([])
  const [file, setFile] = useState("")
  const [expiry, setExipry] = useState("")
  const [imageUrl, setImageUrl] = useState("")
  const [partnerDrawer, setpartnerDrawer] = useState(false)
  const [fileError, setFileError] = useState({ error: false, errorMessage: "" })
  const [openImage, setOpenImage] = useState("")
  const [openModal, setOpenModal] = useState(false)
  const [pdfPreviewOpen, setPdfPreviewOpen] = useState(false)
  const [pdfPreviewUrl, setPdfPreviewUrl] = useState("")
  const [pdfEditOpen, setPdfEditOpen] = useState(false)
  const { notificationRes } = useContext(UserContext)
  const [socialNumberError, setSocialNumberError] = useState({ error: false, message: "" })
  const [vinNumber, setVinNumber] = useState("")
  const [loading, setLoading] = useState(false)
  const { getAccountInfo, account, accountLoading } = PaymentState()
  const navigate = useNavigate()
  const fileInputRef = useRef(null);
  const [mobileData, setMobileData] = useState({
    fh1_pic: "",
    fh1_prev: "",
    fh1_id: "",
    fh1Edit: false,
    laibility_insurance_pic: "",
    laibility_insurance_prev: "",
    laibility_insurance_expiry: "",
    laibility_insurance_id: "",
    laibility_insurance_edit: false,
    dimond_sticker_pic: "",
    dimond_sticker_prev: "",
    dimond_sticker_expiry: "",
    dimond_sticker_number: "",
    dimond_sticker_id: "",
    dimond_sticker_edit: false,
    car_inspection_pic: "",
    car_inspection_prev: "",
    car_inspection_expiry: "",
    car_inspection_id: "",
    car_inspection_edit: false,
    vehicle_reg_pic: "",
    vehicle_reg_prev: "",
    vehicle_reg_expiry: "",
    vehicle_reg_id: "",
    vehicle_reg_edit: false,
    plate_number: "",
    vin_number: "",
    vehicle_pic: "",
    vehicle_prev: "",
    vehicle_id: "",
    vehicle_edit: false,

  })

  // Radio button state for car data type
  const [carDataType, setCarDataType] = useState("")
  const [showCarDataTypeRadio, setShowCarDataTypeRadio] = useState(false)


  const user = JSON.parse(localStorage.getItem("user"))

  const handleClick = () => {
    fileInputRef.current.click();
  };

  // Function to check if any fields have been modified
  const checkFieldsModified = useCallback(() => {
    const hasChanges =
      mobileData.fh1Edit ||
      mobileData.laibility_insurance_edit ||
      mobileData.dimond_sticker_edit ||
      mobileData.car_inspection_edit ||
      mobileData.vehicle_reg_edit ||
      mobileData.vehicle_edit;

    setShowCarDataTypeRadio(hasChanges);

    // Reset car data type if no changes
    if (!hasChanges) {
      setCarDataType("");
    }
  }, [mobileData]);

  // Check for field modifications whenever mobileData changes
  useEffect(() => {
    checkFieldsModified();
  }, [mobileData, checkFieldsModified]);

  console.log("carDataType=====>", carDataType)
  // const getData = async () => {
  //     try {

  //       console.log("render====>")
  //       if (user?.form_name === "drive_with_us") {
  //         await GetDriveWithUs()
  //       } else if (user?.form_name === "partner_with_us") {
  //         await GetPartnerWithUs()
  //       } else if (user?.form_name === "free_ride") {
  //         await GetFreeRide()
  //       }

  //     } catch (error) {
  //       console.log(error)

  //     }
  //   }

  useEffect(() => {
    lightbox.option({
      'resizeDuration': 200,
      'wrapAround': true,
    });

    setOpenDrawer(false)
    setOpenMobileDrawer(false)
    // Do not reset mobileData here!
    // Instead, trigger a data refresh after update (see next effect)
    // Also reset car data type and radio visibility
    setCarDataType("");
    setShowCarDataTypeRadio(false);
  }, [notificationRes])

  // After a successful update, fetch latest data
  useEffect(() => {
    if (response && response.success) {
      GetDriveWithUs();
    }
  }, [response, GetDriveWithUs]);

  // When driveWithUsData updates, repopulate mobileData
  useEffect(() => {
    if (driveWithUsData && driveWithUsData.length > 0) {
      driveWithUsData.forEach((item) => {
        if (item.field_name === "vehicle_pic" || item.field_name === "vehicle_reg" || item.field_name === "car_inspection" || item.field_name === "diamond_sticker" || item.field_name === "liability_insurance" || item.field_name === "fh1_insurance") {
          if (item.field_name === "fh1_insurance") {
            setMobileData((prev) => ({ ...prev, fh1_id: item._id, fh1_prev: `${getDisplayUrl(item.file_name, IMAGES_URL)}`, fh1Edit: false }))
          }
          if (item.field_name === "liability_insurance") {
            setMobileData((prev) => ({ ...prev, laibility_insurance_id: item._id, laibility_insurance_prev: `${getDisplayUrl(item.file_name, IMAGES_URL)}`, laibility_insurance_expiry: item.file_expiry.split("T")[0], laibility_insurance_edit: false }))
          }
          if (item.field_name === "diamond_sticker") {
            setMobileData((prev) => ({ ...prev, dimond_sticker_id: item._id, dimond_sticker_prev: `${getDisplayUrl(item.file_name, IMAGES_URL)}`, dimond_sticker_number: item.file_number, dimond_sticker_expiry: item.file_expiry.split("T")[0], dimond_sticker_edit: false }))
          }
          if (item.field_name === "car_inspection") {
            setMobileData((prev) => ({ ...prev, car_inspection_id: item._id, car_inspection_prev: `${getDisplayUrl(item.file_name, IMAGES_URL)}`, car_inspection_expiry: item.file_expiry.split("T")[0], car_inspection_edit: false }))
          }
          if (item.field_name === "vehicle_reg") {
            setMobileData((prev) => ({ ...prev, vehicle_reg_id: item._id, vehicle_reg_prev: `${getDisplayUrl(item.file_name, IMAGES_URL)}`, vehicle_reg_expiry: item.file_expiry.split("T")[0], plate_number: item.plate_number, vin_number: item.pin_number, vehicle_reg_edit: false }))
          }
          if (item.field_name === "vehicle_pic") {
            setMobileData((prev) => ({ ...prev, vehicle_id: item._id, vehicle_prev: `${getDisplayUrl(item.file_name, IMAGES_URL)}`, vehicle_edit: false }))
          }
        }
      })
    }
  }, [driveWithUsData]);

  const formatDate = (date) => {
    const d = new Date(date)
    d.setFullYear(d.getFullYear());
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${dd}`
  }
  useEffect(() => {
    getAccountInfo()
  }, [])


  useEffect(() => {
    if (accountLoading) return;

    const timeoutId = setTimeout(() => {
      if ((account === null || Object.keys(account).length === 0) && user.status === "1") {
        Swal.fire({
          title: "Bank Account Information",
          text: "Kindly provide the required bank account details.",
          icon: "warning"
        }).then((result) => {
          if (result.isConfirmed) {
            navigate("/driver_forms/profile/edit", { state: { tabValue: "2" } })

          }
        })
      }
    }, 2000)
    return () => clearTimeout(timeoutId);
  }, [account, accountLoading])

  const hanldeOpenDrawer = (id, image, date, formName, field_name, plate_number, pin_number, file_number) => {

    if (date != undefined) {

      setDrawerData({
        id: id,
        image: image,
        date: formatDate(date),
        formName: formName,
        field_name: field_name,
        file_number: file_number,
        ...(plate_number ? { plate_number: plate_number } : {}),
        ...(pin_number ? { pin_number: pin_number } : {})
      })
    } else {
      setDrawerData({
        id: id,
        image: image,
        date: null,
        formName: formName,
        field_name: field_name,
        file_number: file_number,
        ...(plate_number ? { plate_number: plate_number } : {}),
        ...(pin_number ? { pin_number: pin_number } : {})
      })
    }

    setImageUrl(CheckExtension(image) === "pdf" ? "/driver_forms/assets/images/pdf.png" : CheckExtension(image) === "docx" ? "/driver_forms/assets/images/word.png" : `${image}`)
    setOpenDrawer(true)
  }
  const hanldeMobileOpenDrawer = (id, image, date, formName, field_name, plate_number, pin_number, file_number) => {

    driveWithUsData.map((item) => {
      if (item.field_name === "vehicle_pic" || item.field_name === "vehicle_reg" || item.field_name === "car_inspection" || item.field_name === "diamond_sticker" || item.field_name === "liability_insurance" || item.field_name === "fh1_insurance") {
        if (item.field_name === "fh1_insurance") {
          setMobileData((prev) => ({ ...prev, fh1_id: item._id, fh1_prev: `${getDisplayUrl(item.file_name, IMAGES_URL)}`, fh1Edit: false }))
        }
        if (item.field_name === "liability_insurance") {
          setMobileData((prev) => ({ ...prev, laibility_insurance_id: item._id, laibility_insurance_prev: `${getDisplayUrl(item.file_name, IMAGES_URL)}`, laibility_insurance_expiry: item.file_expiry.split("T")[0], laibility_insurance_edit: false }))
        }
        if (item.field_name === "diamond_sticker") {
          setMobileData((prev) => ({ ...prev, dimond_sticker_id: item._id, dimond_sticker_prev: `${getDisplayUrl(item.file_name, IMAGES_URL)}`, dimond_sticker_number: item.file_number, dimond_sticker_expiry: item.file_expiry.split("T")[0], dimond_sticker_edit: false }))
        }
        if (item.field_name === "car_inspection") {
          setMobileData((prev) => ({ ...prev, car_inspection_id: item._id, car_inspection_prev: `${getDisplayUrl(item.file_name, IMAGES_URL)}`, car_inspection_expiry: item.file_expiry.split("T")[0], car_inspection_edit: false }))
        }
        if (item.field_name === "vehicle_reg") {
          setMobileData((prev) => ({ ...prev, vehicle_reg_id: item._id, vehicle_reg_prev: `${getDisplayUrl(item.file_name, IMAGES_URL)}`, vehicle_reg_expiry: item.file_expiry.split("T")[0], plate_number: item.plate_number, vin_number: item.pin_number, vehicle_reg_edit: false }))
        }
        if (item.field_name === "vehicle_pic") {
          setMobileData((prev) => ({ ...prev, vehicle_id: item._id, vehicle_prev: `${getDisplayUrl(item.file_name, IMAGES_URL)}`, vehicle_edit: false }))
        }
      }
    })

    // if (date != undefined) {

    //   setMobileDrawerData({
    //     id: id,
    //     image: image,
    //     date: formatDate(date),
    //     formName: formName,
    //     field_name: field_name,
    //     file_number: file_number,
    //     ...(plate_number ? { plate_number: plate_number } : {}),
    //     ...(pin_number ? { pin_number: pin_number } : {})
    //   })
    // } else {
    //   setMobileDrawerData({
    //     id: id,
    //     image: image,
    //     date: null,
    //     formName: formName,
    //     field_name: field_name,
    //     file_number: file_number,
    //     ...(plate_number ? { plate_number: plate_number } : {}),
    //     ...(pin_number ? { pin_number: pin_number } : {})
    //   })
    // }


    setOpenMobileDrawer(true)
  }
  useEffect(() => {
    driveWithUsData.map((item) => {
      if (item.field_name === "vehicle_pic" || item.field_name === "vehicle_reg" || item.field_name === "car_inspection" || item.field_name === "diamond_sticker" || item.field_name === "liability_insurance" || item.field_name === "fh1_insurance") {
        if (item.field_name === "fh1_insurance") {
          setMobileData((prev) => ({ ...prev, fh1_id: item._id, fh1_prev: `${getDisplayUrl(item.file_name, IMAGES_URL)}`, fh1Edit: false }))
        }
        if (item.field_name === "liability_insurance") {
          setMobileData((prev) => ({ ...prev, laibility_insurance_id: item._id, laibility_insurance_prev: `${getDisplayUrl(item.file_name, IMAGES_URL)}`, laibility_insurance_expiry: item.file_expiry.split("T")[0], laibility_insurance_edit: false }))
        }
        if (item.field_name === "diamond_sticker") {
          setMobileData((prev) => ({ ...prev, dimond_sticker_id: item._id, dimond_sticker_prev: `${getDisplayUrl(item.file_name, IMAGES_URL)}`, dimond_sticker_number: item.file_number, dimond_sticker_expiry: item.file_expiry.split("T")[0], dimond_sticker_edit: false }))
        }
        if (item.field_name === "car_inspection") {
          setMobileData((prev) => ({ ...prev, car_inspection_id: item._id, car_inspection_prev: `${getDisplayUrl(item.file_name, IMAGES_URL)}`, car_inspection_expiry: item.file_expiry.split("T")[0], car_inspection_edit: false }))
        }
        if (item.field_name === "vehicle_reg") {
          setMobileData((prev) => ({ ...prev, vehicle_reg_id: item._id, vehicle_reg_prev: `${getDisplayUrl(item.file_name, IMAGES_URL)}`, vehicle_reg_expiry: item.file_expiry.split("T")[0], plate_number: item.plate_number, vin_number: item.pin_number, vehicle_reg_edit: false }))
        }
        if (item.field_name === "vehicle_pic") {
          setMobileData((prev) => ({ ...prev, vehicle_id: item._id, vehicle_prev: `${getDisplayUrl(item.file_name, IMAGES_URL)}`, vehicle_edit: false }))
        }
      }
    })
  }, [driveWithUsData])

  const getExtension = (file) => {
    const s = String(file || "");
    const clean = s.split("?")[0].split("#")[0];
    const parts = clean.split(".");
    return parts.length > 1 ? String(parts[parts.length - 1]).toLowerCase() : "";
  };

  const openPdfPreview = (url) => {
    const u = String(url || "");
    setPdfPreviewUrl(`${u}${u.includes("?") ? "&" : "?"}v=${Date.now()}#navpanes=0&toolbar=0`);
    setPdfEditOpen(false);
    setPdfPreviewOpen(true);
  };

  const closePdfPreview = () => {
    setPdfPreviewOpen(false);
    setPdfPreviewUrl("");
    setPdfEditOpen(false);
  };

  const getFileKind = (urlOrName, fileObj) => {
    // Prefer file object when user selected a new file
    if (fileObj && typeof fileObj === "object") {
      const name = String(fileObj.name || "");
      const type = String(fileObj.type || "").toLowerCase();
      const extFromName = getExtension(name);
      if (type === "application/pdf" || extFromName === "pdf") return "pdf";
      if (extFromName === "docx") return "docx";
    }
    return getExtension(urlOrName);
  };

  const getPreviewSrc = (url, fileObj) => {
    const kind = getFileKind(url, fileObj);
    if (kind === "pdf") return "/driver_forms/assets/images/pdf.png";
    if (kind === "docx") return "/driver_forms/assets/images/word.png";
    return url;
  };

  const handlePreviewClick = (url, fileObj) => {
    const kind = getFileKind(url, fileObj);
    const u = String(url || "");
    if (kind === "pdf") return openPdfPreview(u);
    if (kind === "docx") return window.open(u, "_blank", "noopener,noreferrer");
    return handleOpenModal(u);
  };

  const handleOpenModal = (image) => {
    const ext = getExtension(image);
    const fileUrl = `${image}`;

    if (ext === "docx") {
      window.open(fileUrl, "_blank", "noopener,noreferrer");
      return;
    }
    if (ext === "pdf") {
      openPdfPreview(fileUrl);
      return;
    }

    setOpenModal(true)
    setOpenImage(image)
    setTimeout(() => {
      $(document).ready(() => {
        $(`[href="${fileUrl}"]`).click();
      });
    }, 0);
  }



  const CheckExtension = (file) => getExtension(file)

  const FormatDate = (dates) => {
    const date = new Date(dates)
    const formattedDate = date.toLocaleDateString('en-US', {
      month: 'numeric',
      day: 'numeric',
      year: 'numeric',
    });
    return formattedDate
  }

  const Label = (form_name) => {
    switch (form_name) {
      case "drive_with_us":
        return "Drive With Us"
      case "free_ride":
        return "Free Ride"
      case "partner_with_us":
        return "Partner With Us"

      default:
        break;
    }
  }

  const selectFile = (e) => {
    const files = e.target.files[0]
    const imageUrl = URL.createObjectURL(files)
    setFile(files)
    if (files.name.includes("pdf")) {
      setImageUrl("/driver_forms/assets/images/pdf.png")
    }
    if (files.name.includes("docx")) {

      setImageUrl("/driver_forms/assets/images/word.png")
    }
    if (files.type.includes("image")) {

      setImageUrl(imageUrl)

    }
  }

  const selectMobileFile = async (e, id) => {
    if (!e.target.files || !e.target.files[0]) {
      console.warn('No file selected');
      return;
    }

    try {
      // Add a small delay for mobile devices to ensure proper file handling
      await new Promise(resolve => setTimeout(resolve, 100));
      
      const files = e.target.files[0]
      const imageUrl = URL.createObjectURL(files)

    if (files.name.includes("pdf")) {
      if (e.target.name === "fh1") {
        setMobileData((prev) => ({ ...prev, fh1_pic: files, fh1_prev: imageUrl, fh1Edit: true }))
      } else if (e.target.name === "liability_insurance") {
        setMobileData((prev) => ({ ...prev, laibility_insurance_pic: files, laibility_insurance_prev: imageUrl, laibility_insurance_edit: true }))
      } else if (e.target.name === "diamond_sticker") {
        setMobileData((prev) => ({ ...prev, dimond_sticker_pic: files, dimond_sticker_prev: imageUrl, dimond_sticker_edit: true }))
      } else if (e.target.name === "car_inspection") {
        setMobileData((prev) => ({ ...prev, car_inspection_pic: files, car_inspection_prev: imageUrl, car_inspection_edit: true }))
      } else if (e.target.name === "vehicle_reg") {
        setMobileData((prev) => ({ ...prev, vehicle_reg_pic: files, vehicle_reg_prev: imageUrl, vehicle_reg_edit: true }))
      } else if (e.target.name === "vehicle_pic") {
        setMobileData((prev) => ({ ...prev, vehicle_pic: files, vehicle_prev: imageUrl, vehicle_edit: true }))
      }

    }
    if (files.name.includes("docx")) {
      if (e.target.name === "fh1") {
        setMobileData((prev) => ({ ...prev, fh1_pic: files, fh1_prev: imageUrl, fh1Edit: true }))
      } else if (e.target.name === "liability_insurance") {
        setMobileData((prev) => ({ ...prev, laibility_insurance_pic: files, laibility_insurance_prev: imageUrl, laibility_insurance_edit: true }))
      } else if (e.target.name === "diamond_sticker") {
        setMobileData((prev) => ({ ...prev, dimond_sticker_pic: files, dimond_sticker_prev: imageUrl, dimond_sticker_edit: true }))
      } else if (e.target.name === "car_inspection") {
        setMobileData((prev) => ({ ...prev, car_inspection_pic: files, car_inspection_prev: imageUrl, car_inspection_edit: true }))
      } else if (e.target.name === "vehicle_reg") {
        setMobileData((prev) => ({ ...prev, vehicle_reg_pic: files, vehicle_reg_prev: imageUrl, vehicle_reg_edit: true }))
      } else if (e.target.name === "vehicle_pic") {
        setMobileData((prev) => ({ ...prev, vehicle_pic: files, vehicle_prev: imageUrl, vehicle_edit: true }))
      }
    }
    if (files.type.includes("image")) {
      if (e.target.name === "fh1") {
        setMobileData((prev) => ({ ...prev, fh1_pic: files, fh1_prev: imageUrl, fh1Edit: true }))
      } else if (e.target.name === "liability_insurance") {
        setMobileData((prev) => ({ ...prev, laibility_insurance_pic: files, laibility_insurance_prev: imageUrl, laibility_insurance_edit: true }))
      } else if (e.target.name === "diamond_sticker") {
        setMobileData((prev) => ({ ...prev, dimond_sticker_pic: files, dimond_sticker_prev: imageUrl, dimond_sticker_edit: true }))
      } else if (e.target.name === "car_inspection") {
        setMobileData((prev) => ({ ...prev, car_inspection_pic: files, car_inspection_prev: imageUrl, car_inspection_edit: true }))
      } else if (e.target.name === "vehicle_reg") {
        setMobileData((prev) => ({ ...prev, vehicle_reg_pic: files, vehicle_reg_prev: imageUrl, vehicle_reg_edit: true }))
      } else if (e.target.name === "vehicle_pic") {
        setMobileData((prev) => ({ ...prev, vehicle_pic: files, vehicle_prev: imageUrl, vehicle_edit: true }))
      }

    }

    } catch (error) {
      console.error('Error handling mobile file selection:', error);
    }
  }

  const handleUpdate = () => {
    // Check if there are any changes to update
    const hasFileChange = file !== "";
    const hasVinChange = vinNumber.length > 0 && vinNumber !== drawerData.pin_number;
    const hasOtherChanges = drawerData.plate_number || drawerData.file_number || drawerData.date;

    if (!hasFileChange && !hasVinChange && !hasOtherChanges) {
      Swal.fire({
        title: "No Changes",
        text: "No changes detected. Please make changes before updating.",
        icon: "info"
      });
      return;
    }

    if (drawerData.field_name === "social_security") {
      if (drawerData.file_number.length !== 11) {
        return setSocialNumberError({ error: true, message: "Social security number should be 9 numbers" })
      }
    }

    if (drawerData.field_name === "car_inspection" && drawerData.date) {
      const validation = validateCarInspectionExpiryDate(drawerData.date);
      if (!validation.valid) {
        Swal.fire({ title: "Invalid Date", text: validation.message, icon: "warning" });
        return;
      }
    }
    
    if (showCarDataTypeRadio && !carDataType) {
      Swal.fire({
        title: "Car Data Type Required",
        text: "Please select whether this is new car data or old car data.",
        icon: "warning"
      });
      return;
    }

    // Validate VIN number format if provided
    // if (vinNumber.length > 0) {
    //   const vinRegex = /^[A-HJ-NPR-Z0-9]{17}$/;
    //   if (!vinRegex.test(vinNumber)) {
    //     setFileError({ error: true, errorMessage: "VIN number must be exactly 17 characters long and contain only letters (excluding I, O, Q) and numbers." })
    //     return;
    //   }
    // }

    if (carDataType === "new") {
      const missingFields = [];
      const missingPinNumbers = [];
      const missingExpiryDates = [];

      // Check for missing file
      if (file === "") {
        missingFields.push(drawerData.formName);
      }

      // Check for missing pin number (VIN number)
      if (!vinNumber || vinNumber.trim() === "") {
        missingPinNumbers.push("VIN Number");
      }

      // Check for missing expiry date if the field requires it
      if (drawerData.date !== null && (!drawerData.date || drawerData.date.trim() === "")) {
        missingExpiryDates.push(`${drawerData.formName} Expiry`);
      }

      // Check for missing plate number if it's vehicle registration
      if (drawerData.field_name === "vehicle_reg" && (!drawerData.plate_number || drawerData.plate_number.trim() === "")) {
        missingFields.push("Plate Number");
      }

      // Check for missing file number if required
      if ((drawerData.field_name === "diamond_sticker" || drawerData.field_name === "social_security" || drawerData.field_name === "tlc_license" || drawerData.field_name === "driver_license") && 
          (!drawerData.file_number || drawerData.file_number.trim() === "")) {
        missingFields.push(`${drawerData.formName} Number`);
      }

      // Build error message
      let errorMessage = "";
      if (missingFields.length > 0) {
        errorMessage += `Missing files/fields: ${missingFields.join(", ")}`;
      }
      if (missingPinNumbers.length > 0) {
        errorMessage += errorMessage ? "\n" : "";
        errorMessage += `Missing pin numbers: ${missingPinNumbers.join(", ")}`;
      }
      if (missingExpiryDates.length > 0) {
        errorMessage += errorMessage ? "\n" : "";
        errorMessage += `Missing expiry dates: ${missingExpiryDates.join(", ")}`;
      }

      if (errorMessage) {
        setFileError({ error: true, errorMessage: `For new car data, all fields are required:\n\n${errorMessage}` })
        return;
      }
    } else {
      // For "old car" or no selection, check only the current field
      if (file === "") {
        setFileError({ error: true, errorMessage: `${drawerData.formName} is required` })
        return;
      }
    }

    const formData = new FormData()
    formData.append("id", drawerData.id)
    formData.append("userId", user._id)
    formData.append("formType", "desktop")
    
    // Add the file if it exists
    if (file !== "") {
      formData.append(`${drawerData.field_name}`, file)
    }
    
    // Add plate number if it exists
    if (drawerData.plate_number) {
      formData.append(`${drawerData.field_name}_plate`, drawerData.plate_number)
    }
    
    // Add pin number - use VIN number if available, otherwise use existing pin
    const pinToUse = vinNumber.length > 0 ? vinNumber : (drawerData.pin_number || "")
    formData.append(`${drawerData.field_name}_pin`, pinToUse)
    
    // Add file number if it exists
    if (drawerData.file_number) {
      formData.append(`${drawerData.field_name}_number`, drawerData.file_number)
    }
    
    // Add expiry date if it exists
    if (drawerData.date !== null) {
      formData.append(`${drawerData.field_name}_expiry`, drawerData.date)
    }

    // If this is vehicle_reg field, also update pin numbers for all other fields
    if (drawerData.field_name === "vehicle_reg" && pinToUse) {
      formData.append('liability_insurance_pin', pinToUse);
      formData.append('diamond_sticker_pin', pinToUse);
      formData.append('car_inspection_pin', pinToUse);
      formData.append('fh1_insurance_pin', pinToUse);
      formData.append('vehicle_pic_pin', pinToUse);
    }

    // Add car data type if radio buttons are shown
    if (showCarDataTypeRadio && carDataType) {
      formData.append("carDataType", carDataType);
    }

    UpdateDriveWithUs(formData)
  }
  const handleMobileUpdatebk = () => {
    let vehiclePinNumber = "";

    mobiledrawerData.forEach((item) => {
      if (item.field_name === "vehicle_reg") {
        vehiclePinNumber = item.pin_number; // Store the vehicle registration pin number
      }
    });

    mobiledrawerData.forEach((item) => {
      const formData = new FormData();
      formData.append("id", item.id);
      formData.append("userId", user._id);
      formData.append("formType", "mobile");
      formData.append(`${item.field_name}`, item.file);
      formData.append(`${item.field_name}_plate`, item.plate_number);

      if (item.file_number && item.file_number !== "undefined") {
        formData.append(`${item.field_name}_number`, item.file_number);
      }

      if (item.date !== null && item.date !== "undefiend") {
        formData.append(`${item.field_name}_expiry`, item.date);
      }

      // Assign the vehicle pin number to all other fields that don't have pin_number
      if (item.field_name !== "vehicle_reg") {
        formData.append(`${item.field_name}_pin`, vehiclePinNumber);
      }

      UpdateDriveWithUs(formData);
    });
  };

  const handleMobileUpdate = () => {
    // Check if only VIN number has changed (no file uploads)
    const hasFileChanges = 
      (mobileData.fh1Edit && mobileData.fh1_pic !== mobileData.fh1_prev) ||
      (mobileData.laibility_insurance_edit && mobileData.laibility_insurance_pic !== mobileData.laibility_insurance_prev) ||
      (mobileData.dimond_sticker_edit && mobileData.dimond_sticker_pic !== mobileData.dimond_sticker_prev) ||
      (mobileData.car_inspection_edit && mobileData.car_inspection_pic !== mobileData.car_inspection_prev) ||
      (mobileData.vehicle_reg_edit && mobileData.vehicle_reg_pic !== mobileData.vehicle_reg_prev) ||
      (mobileData.vehicle_edit && mobileData.vehicle_pic !== mobileData.vehicle_prev);

    const hasVinChange = vinNumber.length > 0 && vinNumber !== mobileData.vin_number;

    // If no changes at all, show message
    if (!hasFileChanges && !hasVinChange) {
      Swal.fire({
        title: "No Changes",
        text: "No changes detected. Please make changes before updating.",
        icon: "info"
      });
      return;
    }

    // if (vinNumber.length > 0) {
    //   const vinRegex = /^[A-HJ-NPR-Z0-9]{17}$/;
    //   if (!vinRegex.test(vinNumber)) {
    //     Swal.fire({
    //       title: "Invalid VIN Number",
    //       text: "VIN number must be exactly 17 characters long and contain only letters (excluding I, O, Q) and numbers.",
    //       icon: "warning"
    //     });
    //     return;
    //   }
    // }

    if (showCarDataTypeRadio && !carDataType) {
      Swal.fire({
        title: "Car Data Type Required",
        text: "Please select whether this is new car data or old car data.",
        icon: "warning"
      });
      return;
    }

    if (carDataType === "new") {
      const missingFields = [];
      const missingPinNumbers = [];
      const missingExpiryDates = [];
      
      // Only check for missing files if there are file changes
      if (hasFileChanges) {
        if (!mobileData.fh1_pic || mobileData.fh1_pic === mobileData.fh1_prev) {
          missingFields.push("FH1 Insurance");
        }
        if (!mobileData.laibility_insurance_pic || mobileData.laibility_insurance_pic === mobileData.laibility_insurance_prev) {
          missingFields.push("Liability Insurance");
        }
        if (!mobileData.dimond_sticker_pic || mobileData.dimond_sticker_pic === mobileData.dimond_sticker_prev) {
          missingFields.push("Diamond Sticker");
        }
        if (!mobileData.car_inspection_pic || mobileData.car_inspection_pic === mobileData.car_inspection_prev) {
          missingFields.push("Car Inspection");
        }
        if (!mobileData.vehicle_reg_pic || mobileData.vehicle_reg_pic === mobileData.vehicle_reg_prev) {
          missingFields.push("Vehicle Registration");
        }
        if (!mobileData.vehicle_pic || mobileData.vehicle_pic === mobileData.vehicle_prev) {
          missingFields.push("Vehicle Picture");
        }
      }

      // Check for missing pin number (VIN number) - always required for new car
      if (!vinNumber || vinNumber.trim() === "") {
        missingPinNumbers.push("VIN Number");
      }

      // Only check expiry dates if there are file changes
      if (hasFileChanges) {
        if (!mobileData.laibility_insurance_expiry || mobileData.laibility_insurance_expiry.trim() === "") {
          missingExpiryDates.push("Liability Insurance Expiry");
        }
        if (!mobileData.dimond_sticker_expiry || mobileData.dimond_sticker_expiry.trim() === "") {
          missingExpiryDates.push("Diamond Sticker Expiry");
        }
        if (!mobileData.car_inspection_expiry || mobileData.car_inspection_expiry.trim() === "") {
          missingExpiryDates.push("Car Inspection Expiry");
        }
        if (!mobileData.vehicle_reg_expiry || mobileData.vehicle_reg_expiry.trim() === "") {
          missingExpiryDates.push("Vehicle Registration Expiry");
        }

        if (mobileData.car_inspection_expiry) {
          const validation = validateCarInspectionExpiryDate(mobileData.car_inspection_expiry);
          if (!validation.valid) {
            Swal.fire({ title: "Invalid Date", text: validation.message, icon: "warning" });
            return;
          }
        }

        // Check for missing plate number
        if (!mobileData.plate_number || mobileData.plate_number.trim() === "") {
          missingFields.push("Plate Number");
        }

        // Check for missing diamond sticker number
        if (!mobileData.dimond_sticker_number || mobileData.dimond_sticker_number.trim() === "") {
          missingFields.push("Diamond Sticker Number");
        }
      }

      // Build error message
      let errorMessage = "";
      if (missingFields.length > 0) {
        errorMessage += `Missing files/fields: ${missingFields.join(", ")}`;
      }
      if (missingPinNumbers.length > 0) {
        errorMessage += errorMessage ? "\n" : "";
        errorMessage += `Missing pin numbers: ${missingPinNumbers.join(", ")}`;
      }
      if (missingExpiryDates.length > 0) {
        errorMessage += errorMessage ? "\n" : "";
        errorMessage += `Missing expiry dates: ${missingExpiryDates.join(", ")}`;
      }

      if (errorMessage) {
        Swal.fire({
          title: "Required Fields Missing",
          text: `For new car data, all fields are required:\n\n${errorMessage}`,
          icon: "warning"
        });
        return;
      }
    } else {
      // For "old car" or no selection, check only modified fields that have file changes
      if (hasFileChanges) {
        if (
          (mobileData.laibility_insurance_edit && !mobileData.laibility_insurance_pic) ||
          (mobileData.dimond_sticker_edit && !mobileData.dimond_sticker_pic) ||
          (mobileData.car_inspection_edit && !mobileData.car_inspection_pic) ||
          (mobileData.vehicle_reg_edit && !mobileData.vehicle_reg_pic)
        ) {
          return;
        }
      }
      if (mobileData.car_inspection_expiry && mobileData.car_inspection_expiry.trim() !== "") {
        const validation = validateCarInspectionExpiryDate(mobileData.car_inspection_expiry);
        if (!validation.valid) {
          Swal.fire({ title: "Invalid Date", text: validation.message, icon: "warning" });
          return;
        }
      }
    }

    // If validation passes, proceed with update
    {
      const formData = new FormData();
      formData.append("userId", user._id);
      formData.append("formType", "mobile");

      // Add car data type if radio buttons are shown
      if (showCarDataTypeRadio && carDataType) {
        formData.append("carDataType", carDataType);
      }

      // Get the pin number to use (VIN number takes priority)
      const pinToUse = vinNumber.length > 0 ? vinNumber : mobileData.vin_number;

      // Append only changed files and their associated data
      if (mobileData.fh1Edit && mobileData.fh1_pic !== mobileData.fh1_prev) {
        formData.append("fh1_id", mobileData.fh1_id);
        formData.append("fh1_insurance", mobileData.fh1_pic);
        formData.append("fh1_insurance_pin", pinToUse);
      }

      if (mobileData.laibility_insurance_edit && mobileData.laibility_insurance_pic !== mobileData.laibility_insurance_prev) {
        formData.append("laibility_insurance_id", mobileData.laibility_insurance_id);
        formData.append("liability_insurance", mobileData.laibility_insurance_pic);
        formData.append("liability_insurance_expiry", mobileData.laibility_insurance_expiry);
        formData.append("liability_insurance_pin", pinToUse);
      }

      if (mobileData.dimond_sticker_edit && mobileData.dimond_sticker_pic !== mobileData.dimond_sticker_prev) {
        formData.append("dimond_sticker_id", mobileData.dimond_sticker_id);
        formData.append("diamond_sticker", mobileData.dimond_sticker_pic);
        formData.append("diamond_sticker_expiry", mobileData.dimond_sticker_expiry);
        formData.append("diamond_sticker_number", mobileData.dimond_sticker_number);
        formData.append("diamond_sticker_pin", pinToUse);
      }

      if (mobileData.car_inspection_edit && mobileData.car_inspection_pic !== mobileData.car_inspection_prev) {
        formData.append("car_inspection_id", mobileData.car_inspection_id);
        formData.append("car_inspection", mobileData.car_inspection_pic);
        formData.append("car_inspection_expiry", mobileData.car_inspection_expiry);
        formData.append("car_inspection_pin", pinToUse);
      }

      if (mobileData.vehicle_reg_edit && mobileData.vehicle_reg_pic !== mobileData.vehicle_reg_prev) {
        formData.append("vehicle_reg_id", mobileData.vehicle_reg_id);
        formData.append("vehicle_reg", mobileData.vehicle_reg_pic);
        formData.append("vehicle_reg_expiry", mobileData.vehicle_reg_expiry);
        formData.append("vehicle_reg_plate", mobileData.plate_number);
        formData.append("vehicle_reg_pin", pinToUse);
      }

      if (mobileData.vehicle_edit && mobileData.vehicle_pic !== mobileData.vehicle_prev) {
        formData.append("vehicle_id", mobileData.vehicle_id);
        formData.append("vehicle_pic", mobileData.vehicle_pic);
        formData.append("vehicle_pic_pin", pinToUse);
      }

      // If VIN number has changed, update pin numbers for all fields even if files haven't changed
      if (vinNumber.length > 0 && vinNumber !== mobileData.vin_number) {
        // Add pin updates for all fields that have IDs
        if (mobileData.fh1_id) {
          formData.append("fh1_insurance_pin", pinToUse);
        }
        if (mobileData.laibility_insurance_id) {
          formData.append("liability_insurance_pin", pinToUse);
        }
        if (mobileData.dimond_sticker_id) {
          formData.append("diamond_sticker_pin", pinToUse);
        }
        if (mobileData.car_inspection_id) {
          formData.append("car_inspection_pin", pinToUse);
        }
        if (mobileData.vehicle_reg_id) {
          formData.append("vehicle_reg_pin", pinToUse);
        }
        if (mobileData.vehicle_id) {
          formData.append("vehicle_pic_pin", pinToUse);
        }
      }

      UpdateDriveWithUs(formData);
    }


  };


  // const hanldePartnerDrawer = () => {
  //   setDrawerData({
  //     institution_name: partnerWithUsData[0].institution_name,
  //     industry: partnerWithUsData[0].industry,
  //     other_industry: partnerWithUsData[0].other_industry,
  //     additional_info: partnerWithUsData[0].additional_info
  //   })
  //   setpartnerDrawer(true)
  // }
  useEffect(() => {
    const checkMobile = () => {
      const isMobile = window.innerWidth <= 768

      if (isMobile) {
        setValue(0)
      }
    }
    if (user.form_name !== "drive_with_us") {
      checkMobile();
      window.addEventListener('resize', checkMobile);
      return () => {
        window.removeEventListener('resize', checkMobile);
      };
    }

  }, [user])


  function isExpired(dateString) {
    const givenDate = new Date(dateString);
    const currentDate = new Date();

    return givenDate < currentDate;
  }

  useEffect(() => {

    if (driveWithUsData.length > 0 || partnerWithUsData.length > 0 || freeRideData.length > 0) {
      if (
        user?.form_name === "drive_with_us" &&
        driveWithUsData.some((item) => isExpired(item.file_expiry) || item.file_status === 2) &&
        window.innerWidth > 768
      ) {
        setValue(1);
      } else if (
        user?.form_name === "free_ride" ||
        user?.form_name === "partner_with_us"
      ) {

        setValue(1);
      } else if (window.innerWidth < 768) {

        setValue(value);
      } else {
        setValue(2)
      }
    }
  }, [partnerWithUsData, freeRideData, driveWithUsData]);





  return (
    <>
      {loading ? <Box sx={{ height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }} ><Spinner style={{ color: "rgb(146, 195, 35)" }} /></Box> :
        <Card variant="elevation" className="setting-card" sx={{ height: "100%", width: "100%", boxShadow: { sm: 0, md: 3 }, backgroundColor: { sm: "transparent", md: "#FFF" } }}>
          {openModal && (
            <a
              href={`${openImage}`}
              data-lightbox="gallery"
              data-title="Image"
              style={{ display: 'none' }}
            >
              Open Image
            </a>
          )}
          <Modal open={pdfPreviewOpen} onClose={closePdfPreview}>
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: { xs: "95%", md: "80%" },
                height: { xs: "85vh", md: "85vh" },
                bgcolor: "#fff",
                boxShadow: 24,
                borderRadius: 2,
                overflow: "hidden",
                display: "flex",
                flexDirection: "column"
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", px: 2, py: 1, borderBottom: "1px solid #eee" }}>
                <Typography sx={{ fontWeight: 600 }}>PDF Preview</Typography>
                <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                  <Button variant="outlined" size="small" disabled={!pdfPreviewUrl} onClick={() => setPdfEditOpen((v) => !v)}>
                    {pdfEditOpen ? "Close Edit" : "Edit"}
                  </Button>
                  {pdfEditOpen && (
                    <Button
                      variant="contained"
                      size="small"
                      sx={{ backgroundColor: "#92c323", '&:hover': { backgroundColor: "#76a521" } }}
                      disabled={!pdfPreviewUrl}
                      onClick={() => {
                        if (pdfPreviewUrl) window.open(pdfPreviewUrl, "_blank", "noopener,noreferrer");
                      }}
                    >
                      Open
                    </Button>
                  )}
                  <IconButton onClick={closePdfPreview}>
                    <Close />
                  </IconButton>
                </Box>
              </Box>
              <Box sx={{ flex: 1 }}>
                {pdfPreviewUrl ? (
                  pdfEditOpen ? (
                    <iframe
                      key={`${String(pdfPreviewUrl).split("#")[0]}|iframe`}
                      title="pdf-preview"
                      src={String(pdfPreviewUrl).split("#")[0]}
                      style={{ width: "100%", height: "100%", border: "none" }}
                    />
                  ) : (
                    <PdfCanvasPreview url={pdfPreviewUrl} />
                  )
                ) : null}
              </Box>
            </Box>
          </Modal>
          <Drawer anchor="right" open={openDrawer} onClose={() => setOpenDrawer(false)} >
            <Box sx={{ width: { xs: "100%", md: 500 } }} p={5}   >
              <IconButton onClick={() => setOpenDrawer(false)} >
                <Close />
              </IconButton>
              <Box textAlign={"center"}>
                <Typography variant="h5"  >{drawerData.formName}</Typography>
                <img
                  src={imageUrl}
                  style={{ height: 140, width: 140, paddingTop: 20 }}
                />
              </Box>


            </Box>
            <Box px={5} sx={{ flexDirection: "column" }}   >
              <label style={{ color: "#000" }} >{drawerData.formName}</label>
              <TextField type="file" error={fileError.error} helperText={fileError.errorMessage} fullWidth onChange={selectFile} />
            </Box>

            {drawerData.date !== null && (
              <Box px={5} pt={4} sx={{ flexDirection: "column" }}   >
                <label style={{ color: "#000" }} >{drawerData.formName} expiry{drawerData.field_name === "car_inspection" && drawerData.date ? `  — Expires: ${getEffectiveCarInspectionExpiryDisplay(drawerData.date)}` : ""}</label>
                <TextField
                  type="date"
                  value={drawerData.date}
                  onChange={(e) => setDrawerData((prev) => ({ ...prev, date: e.target.value }))}
                  fullWidth
                />
              </Box>
            )}
            {(drawerData.field_name === "social_security" || drawerData.field_name === "diamond_sticker" || drawerData.field_name === "tlc_license" || drawerData.field_name === "driver_license") && (
              <Box px={5} pt={4} sx={{ flexDirection: "column" }}   >
                <label style={{ color: "#000" }} > {drawerData.formName} Number </label>
                <TextField type="text" value={drawerData.file_number} onChange={(e) => {
                  const input = e.target.value.replace(/\D/g, '');
                  if (drawerData.field_name === "social_security") {
                    const formattedInput = input.replace(/(\d{3})(\d{2})?(\d{4})?/, (match, p1, p2, p3) => {
                      let result = p1;
                      if (p2) result += `-${p2}`;
                      if (p3) result += `-${p3}`;
                      return result;
                    });
                    if (socialNumberError.error && formattedInput.length === 11) {
                      setSocialNumberError({ error: false, message: "" })
                    } else {
                      setSocialNumberError({ error: true, message: "Social security number should be 9 numbers" })
                    }
                    setDrawerData((prev) => ({ ...prev, file_number: formattedInput }))
                  } else {
                    setDrawerData((prev) => ({ ...prev, file_number: e.target.value }))
                  }



                }} fullWidth error={socialNumberError.error} helperText={socialNumberError.message} />
              </Box>
            )}
            {drawerData.formName === "Vehicle reg" && (
              <Box px={5} pt={4} sx={{ flexDirection: "column" }}   >
                <label style={{ color: "#000" }} > Plate Number </label>
                <TextField type="text" value={drawerData.plate_number} onChange={(e) => setDrawerData((prev) => ({ ...prev, plate_number: e.target.value }))} fullWidth />
              </Box>
            )}
            {drawerData.formName === "Vehicle reg" && (
              <Box px={5} pt={4} sx={{ flexDirection: "column" }}   >
                <label style={{ color: "#000" }} > Vin Number </label>
                <TextField type="text" value={drawerData.pin_number} onChange={(e) => setDrawerData((prev) => ({ ...prev, pin_number: e.target.value }))} fullWidth />
              </Box>
            )}
            <Box px={5} pt={3} >
              <Button sx={{ backgroundColor: "#92c323", '&:hover': { backgroundColor: "#76a521" } }} onClick={handleUpdate} fullWidth size="large" variant="contained" color="secondary">
                {formBusy ? "Please wait...." : "Update"}
              </Button>
            </Box>
          </Drawer>
          <Drawer anchor="right" open={openMobileDrawer} onClose={() => { setOpenMobileDrawer(false); setMobileDrawerData([]) }} >
            <Box sx={{ width: { xs: "100%", md: 500 } }} p={5}   >
              <IconButton onClick={() => { setOpenMobileDrawer(false); setMobileDrawerData([]) }} >
                <Close />
              </IconButton>



            </Box>
            {/* {driveWithUsData.map((item) => {
             if (item.field_name === "vehicle_pic" || item.field_name === "vehicle_reg" || item.field_name === "car_inspection" || item.field_name === "diamond_sticker" || item.field_name === "liability_insurance" || item.field_name === "fh1_insurance") {
            return(
            <Box p={5} >
              <Box  >
                <Typography variant="h5"  >{item.field_title}</Typography>
                <Box textAlign={"center"} >
                  <img
                    src={`${item.file_name}`}
                    style={{ height: 140, width: 140, paddingTop: 20 }}
                  />
                </Box>

              </Box>



              <Box px={5} sx={{ flexDirection: "column" }}   >
                <label style={{ color: "#000" }} >{item.field_title}</label>
                <TextField type="file" error={item.fileError} helperText={item.fileMessage} fullWidth onChange={(e) => selectMobileFile(e, item.id)} />
              </Box>

              {item.file_expiry && item.file_expiry !== "undefined" && (
                <Box px={5} pt={4} sx={{ flexDirection: "column" }}   >
                  <label style={{ color: "#000" }} >{item.field_title} expiry </label>
                  <TextField type="date" value={item.file_expiry.split("T")[0]} onChange={(e) => {
                    setMobileDrawerData((prev) =>
                      prev.map((dataItem) =>
                        dataItem.id === item.id
                          ? { ...dataItem, date: e.target.value, isEdit: true } 
                          : dataItem
                      )
                    );
                  }} fullWidth />
                </Box>
              )}
              {item.file_number && item.file_number !== "undefined" && (
                <Box px={5} pt={4} sx={{ flexDirection: "column" }}   >
                  <label style={{ color: "#000" }} > {item.field_title} Number </label>
                  <TextField type="text" value={item.file_number} onChange={(e) => {
                    setMobileDrawerData((prev) =>
                      prev.map((dataItem) =>
                        dataItem.id === item.id
                          ? { ...dataItem, file_number: e.target.value, isEdit: true } 
                          : dataItem
                      )
                    );
                  }} fullWidth />
                </Box>
              )}

              {item.plate_number && item.plate_number !=="undefined" && (
                <Box px={5} pt={4} sx={{ flexDirection: "column" }}   >
                  <label style={{ color: "#000" }} > Plate Number </label>
                  <TextField type="text" value={item.plate_number} onChange={(e) => {
                    setMobileDrawerData((prev) =>
                      prev.map((dataItem) =>
                        dataItem.id === item.id
                          ? { ...dataItem, plate_number: e.target.value, isEdit: true } 
                          : dataItem
                      )
                    );
                  }} fullWidth />
                </Box>
              )}

              {item.field_name === "vehicle_reg" && (
                <Box px={5} pt={4} sx={{ flexDirection: "column" }}   >
                  <label style={{ color: "#000" }} > Vin Number </label>
                  <TextField type="text" value={item.pin_number} onChange={(e) => {
                    setVinNumber(e.target.value);
                    setMobileDrawerData((prev) =>
                      prev.map((dataItem) =>
                        dataItem.id === item.id
                          ? { ...dataItem, pin_number: "", isEdit: false } 
                          : dataItem
                      )
                    );

                  }} fullWidth />
                </Box>
              )}
            </Box>
            )
          }
})} */}

            <Box p={5} >
              <IconButton onClick={() => setValue(0)} sx={{ backgroundColor: "#021b38", m: 2, px: 3, color: "#FFF", borderRadius: 2, '&:hover': { backgroundColor: "#76a521" } }} variant="contained" size="icon" className="d-flex d-md-none"   >
                <FontAwesomeIcon icon={faChevronLeft} />
              </IconButton>
              <Box  >
                <Typography variant="h5"  >Fh1 Insurance</Typography>
                <Box textAlign={"center"} >
                  <img
                    src={getPreviewSrc(mobileData.fh1_prev, mobileData.fh1_pic)}
                    onClick={() => handlePreviewClick(mobileData.fh1_prev, mobileData.fh1_pic)}
                    style={{ height: 140, width: 140, paddingTop: 20, cursor: "pointer" }}
                  />
                </Box>
                <Box px={5} sx={{ flexDirection: "column" }}   >
                  <label style={{ color: "#000" }} >Fh1 Insurance</label>
                  <TextField error={mobileData.fh1Edit && mobileData.fh1_pic === ""} helperText={mobileData.fh1Edit && mobileData.fh1_pic === "" ? "Image is required" : ""} type="file" name="fh1" fullWidth onChange={(e) => selectMobileFile(e)} />
                </Box>

              </Box>
              <Box mt={5} >
                <Typography variant="h5"  >Liability Insurance</Typography>
                <Box textAlign={"center"} >
                  <img
                    src={getPreviewSrc(mobileData.laibility_insurance_prev, mobileData.laibility_insurance_pic)}
                    onClick={() => handlePreviewClick(mobileData.laibility_insurance_prev, mobileData.laibility_insurance_pic)}
                    style={{ height: 140, width: 140, paddingTop: 20, cursor: "pointer" }}
                  />
                </Box>
                <Box px={5} sx={{ flexDirection: "column" }}   >
                  <label style={{ color: "#000" }} >Liability Insurance</label>
                  <TextField error={mobileData.laibility_insurance_edit && mobileData.laibility_insurance_pic === ""} helperText={mobileData.laibility_insurance_edit && mobileData.laibility_insurance_pic === "" ? "Image is required" : ""} type="file" name="liability_insurance" fullWidth onChange={(e) => selectMobileFile(e)} />
                </Box>
                <Box px={5} pt={4} sx={{ flexDirection: "column" }}   >
                  <label style={{ color: "#000" }} >Liability Insurance expiry </label>
                  <TextField type="date" value={mobileData.laibility_insurance_expiry} onChange={(e) => {
                    setMobileData((prev) => ({ ...prev, laibility_insurance_expiry: e.target.value, laibility_insurance_edit: true }))
                  }} fullWidth />
                </Box>
              </Box>
              <Box mt={5} >
                <Typography variant="h5"  >Diamond sticker</Typography>
                <Box textAlign={"center"} >
                  <img
                    src={getPreviewSrc(mobileData.dimond_sticker_prev, mobileData.dimond_sticker_pic)}
                    onClick={() => handlePreviewClick(mobileData.dimond_sticker_prev, mobileData.dimond_sticker_pic)}
                    style={{ height: 140, width: 140, paddingTop: 20, cursor: "pointer" }}
                  />
                </Box>
                <Box px={5} sx={{ flexDirection: "column" }}   >
                  <label style={{ color: "#000" }} >Diamond sticker</label>
                  <TextField error={mobileData.dimond_sticker_edit && mobileData.dimond_sticker_pic === ""} helperText={mobileData.dimond_sticker_edit && mobileData.dimond_sticker_pic === "" ? "Image is required" : ""} type="file" name="diamond_sticker" fullWidth onChange={(e) => selectMobileFile(e)} />
                </Box>
                <Box px={5} pt={4} sx={{ flexDirection: "column" }}   >
                  <label style={{ color: "#000" }} >Diamond sticker expiry </label>
                  <TextField type="date" value={mobileData.dimond_sticker_expiry} onChange={(e) => {
                    setMobileData((prev) => ({ ...prev, dimond_sticker_expiry: e.target.value, dimond_sticker_edit: true }))
                  }} fullWidth />
                </Box>
                <Box px={5} pt={4} sx={{ flexDirection: "column" }}   >
                  <label style={{ color: "#000" }} > Diamond sticker Number </label>
                  <TextField type="text" value={mobileData.dimond_sticker_number} onChange={(e) => {
                    setMobileData((prev) => ({ ...prev, dimond_sticker_number: e.target.value, dimond_sticker_edit: true }))
                  }} fullWidth />
                </Box>


              </Box>
              <Box mt={5} >
                <Typography variant="h5"  >Car inspection</Typography>
                <Box textAlign={"center"} >
                  <img
                    src={getPreviewSrc(mobileData.car_inspection_prev, mobileData.car_inspection_pic)}
                    onClick={() => handlePreviewClick(mobileData.car_inspection_prev, mobileData.car_inspection_pic)}
                    style={{ height: 140, width: 140, paddingTop: 20, cursor: "pointer" }}
                  />
                </Box>
                <Box px={5} sx={{ flexDirection: "column" }}   >
                  <label style={{ color: "#000" }} >Car inspection</label>
                  <TextField error={mobileData.car_inspection_edit && mobileData.car_inspection_pic === ""} helperText={mobileData.car_inspection_edit && mobileData.car_inspection_pic === "" ? "Image is required" : ""} type="file" name="car_inspection" fullWidth onChange={(e) => selectMobileFile(e)} />
                </Box>
                <Box px={5} pt={4} sx={{ flexDirection: "column" }}   >
                  <label style={{ color: "#000" }} >Car inspection expiry{mobileData.car_inspection_expiry ? `  — Expires: ${getEffectiveCarInspectionExpiryDisplay(mobileData.car_inspection_expiry)}` : ""}</label>
                  <TextField
                    type="date"
                    value={mobileData.car_inspection_expiry}
                    onChange={(e) => {
                      setMobileData((prev) => ({ ...prev, car_inspection_expiry: e.target.value, car_inspection_edit: true }))
                    }}
                    fullWidth
                  />
                </Box>
              </Box>
              <Box mt={5} >
                <Typography variant="h5"  >Vehicle reg</Typography>
                <Box textAlign={"center"} >
                  <img
                    src={getPreviewSrc(mobileData.vehicle_reg_prev, mobileData.vehicle_reg_pic)}
                    onClick={() => handlePreviewClick(mobileData.vehicle_reg_prev, mobileData.vehicle_reg_pic)}
                    style={{ height: 140, width: 140, paddingTop: 20, cursor: "pointer" }}
                  />
                </Box>
                <Box px={5} sx={{ flexDirection: "column" }}   >
                  <label style={{ color: "#000" }} >Vehicle reg</label>
                  <TextField error={mobileData.vehicle_reg_edit && mobileData.vehicle_reg_pic === ""} helperText={mobileData.vehicle_reg_edit && mobileData.vehicle_reg_pic === "" ? "Image is required" : ""} type="file" name="vehicle_reg" fullWidth onChange={(e) => selectMobileFile(e)} />
                </Box>
                <Box px={5} pt={4} sx={{ flexDirection: "column" }}   >
                  <label style={{ color: "#000" }} >Vehicle reg expiry </label>
                  <TextField type="date" value={mobileData.vehicle_reg_expiry} onChange={(e) => {
                    setMobileData((prev) => ({ ...prev, vehicle_reg_expiry: e.target.value, vehicle_reg_edit: true }))
                  }} fullWidth />
                </Box>
                <Box px={5} pt={4} sx={{ flexDirection: "column" }}   >
                  <label style={{ color: "#000" }} > Plate Number </label>
                  <TextField type="text" value={mobileData.plate_number} onChange={(e) => {
                    setMobileData((prev) => ({ ...prev, plate_number: e.target.value, vehicle_reg_edit: true }))
                  }} fullWidth />
                </Box>
                <Box px={5} pt={4} sx={{ flexDirection: "column" }}   >
                  <label style={{ color: "#000" }} > Vin Number </label>
                  <TextField type="text" value={vinNumber !== "" ? vinNumber : mobileData.vin_number} onChange={(e) => {
                    setVinNumber(e.target.value); setMobileData((prev) => ({ ...prev, vehicle_reg_edit: true, laibility_insurance_edit: true, dimond_sticker_edit: true, car_inspection_edit: true, vehicle_edit: true, vehicle_reg_edit: true, fh1Edit: true }))
                  }} fullWidth />
                </Box>


              </Box>
              <Box mt={5} >
                <Typography variant="h5"  >Vehicle pic</Typography>
                <Box textAlign={"center"} >
                  <img
                    src={getPreviewSrc(mobileData.vehicle_prev, mobileData.vehicle_pic)}
                    onClick={() => handlePreviewClick(mobileData.vehicle_prev, mobileData.vehicle_pic)}
                    style={{ height: 140, width: 140, paddingTop: 20, cursor: "pointer" }}
                  />
                </Box>
                <Box px={5} sx={{ flexDirection: "column" }}   >
                  <label style={{ color: "#000" }} >Vehicle pic</label>
                  <TextField error={mobileData.vehicle_edit && mobileData.vehicle_pic === ""} helperText={mobileData.vehicle_edit && mobileData.vehicle_pic === "" ? "Image is required" : ""} type="file" name="vehicle_pic" fullWidth onChange={(e) => selectMobileFile(e)} />
                </Box>

              </Box>

            </Box>





            <Box px={5} pt={3} >
              <Button sx={{ backgroundColor: "#92c323", '&:hover': { backgroundColor: "#76a521" } }} onClick={handleMobileUpdate} fullWidth size="large" variant="contained" color="secondary">
                {formBusy ? "Please wait...." : "Update"}
              </Button>
            </Box>
          </Drawer>
          {/* <Drawer anchor="right" open={partnerDrawer} onClose={() => setpartnerDrawer(false)} >
        <Box sx={{ width: 700 }} >
          <Container>
            <Typography variant="h5" pt={4} textAlign={"center"}  >Partner with us</Typography>
            <Grid container pt={4}   >
              <Grid md={6} px={2} pt={3} >
                <label style={{ color: "#000" }} >Institution name</label>
                <TextField value={drawerData.institution_name} onChange={(e) => setDrawerData((prev) => ({ ...prev, institution_name: e.target.value }))} fullWidth />
              </Grid>
              <Grid md={6} px={2} pt={3} >
                <label style={{ color: "#000" }} >Industry</label>
                <TextField fullWidth value={drawerData.industry} onChange={(e) => setDrawerData((prev) => ({ ...prev, industry: e.target.value }))} />
              </Grid>
              <Grid md={6} px={2} pt={3} >
                <label style={{ color: "#000" }} >Other industry</label>
                <TextField fullWidth value={drawerData.other_industry} onChange={(e) => setDrawerData((prev) => ({ ...prev, other_industry: e.target.value }))} />
              </Grid>
              <Grid md={6} px={2} pt={3} >
                <label style={{ color: "#000" }} >Additional Info</label>
                <TextField fullWidth value={drawerData.additional_info} onChange={(e) => setDrawerData((prev) => ({ ...prev, additional_info: e.target.value }))} />
              </Grid>

            </Grid>
            <Box px={5} pt={3} >
              <Button onClick={handleUpdate} fullWidth size="large" variant="contained" color="secondary">
                {formBusy ? "Please wait...." : "Update"}
              </Button>
            </Box>
          </Container>
        </Box>
      </Drawer> */}
          {/* TABS */}
          <br></br>
          {/* <Stack direction={{ xs: "column-reverse", sm: "row" }} alignItems={"center"} justifyContent={"space-between"} >



          {user?.form_name === "drive_with_us" && (
            <Box mx={2} px={2} width={{ xs: "100%", sm: "auto" }} >
              <Button
                variant="contained"
                color="secondary"

                onClick={hanldeMobileOpenDrawer}
                sx={{ p: 1, my: 0, backgroundColor: "#92c323", '&:hover': { backgroundColor: "#76a521" }, width: { xs: "100%", sm: "auto" } }}
              >

                Update Car Information
              </Button>
            </Box>
          )}
        </Stack> */}
          <Divider className="d-none d-md-block" ></Divider>

          {/* MAIN CONTENT CONTAINER */}
          <form>
            <CardContent
              sx={{


                textAlign: { md: "start" },
                display: { xs: "none", md: "block" }

              }}
              className="p-0"
            >
              {value === 1 ?
                user?.form_name === "drive_with_us" ?
                  <Grid container spacing={2} m={2} >

                    {driveWithUsData
                      .filter((item) => isExpired(item.file_expiry) || item.file_status === 2)
                      .map((item) => (

                        <Grid item xs={12} lg={4} key={item._id} >
                          {/* <Card elevation={4} sx={{ height: "100%", width: "100%" }} >
                          <Grid container mt={3}  >
                            <Grid xs={12} justifyContent={"space-around"} alignItems={"center"} flexDirection={"column"} display={"flex"}  >
                              <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"} width={"100%"} spacing={2} px={1} mb={2}  >
                                {RenderStatus(String(item.file_status))}
                                <Button sx={{ color: "#92c323" }} size="small" onClick={() => hanldeOpenDrawer(item._id, item.file_name, item.file_expiry, item.field_title, item.field_name, item.plate_number, item.pin_number, item.file_number)} >Update File</Button>

                              </Stack>

                              <Typography fontWeight={900} fontSize={12} mb={1} >{item.field_title}</Typography>
                              {item.file_number && item.file_number !== "undefined" && (
                                <Typography mb={1} fontSize={14} >{item.file_number}</Typography>
                              )}
                              {item.field_name === "vehicle_reg" ?
                                <Stack direction={"row"} justifyContent={"space-between"} width="100%" alignItems={"center"}  >

                                  <Box width="100%" textAlign={"center"} >
                                    <Typography fontSize={14} fontWeight={700} >Plate Number</Typography>
                                    <Typography fontSize={12} >{item.plate_number}</Typography>
                                  </Box>
                                  <img onClick={() => handleOpenModal(item.file_name)} style={{ height: 150, width: 150, cursor: "pointer" }} src={CheckExtension(item.file_name) === "pdf" ? "/driver_forms/assets/images/pdf.png" : CheckExtension(item.file_name) === "docx" ? "/driver_forms/assets/images/word.png" : `${item.file_name}`} />
                                  <Box width="100%" textAlign={"center"} >
                                    <Typography fontSize={14} fontWeight={700} >Vin Number</Typography>
                                    <Typography fontSize={12} >{item.pin_number}</Typography>
                                  </Box>
                                </Stack>
                                :
                                <img onClick={() => handleOpenModal(item.file_name)} style={{ height: 150, width: 150, cursor: "pointer" }} src={CheckExtension(item.file_name) === "pdf" ? "/driver_forms/assets/images/pdf.png" : CheckExtension(item.file_name) === "docx" ? "/driver_forms/assets/images/word.png" : `${item.file_name}`} />
                              }
                              
                            </Grid>
                            {item.file_expiry && (
                              <Grid xs={12} display={"flex"} flexDirection={"column"} alignItems={"center"} justifyContent={"space-evenly"}  >
                                <Typography mt={2} fontSize={12} fontWeight={900} >Expiry</Typography>
                                <Typography mt={2} mb={2} color={isExpired(item.file_expiry) ? "red" : "black"} >{FormatDate(item.file_expiry)}</Typography>
                              </Grid>
                            )}


                          </Grid>
                        </Card> */}
                          <Card className="h-100" elevation={5}  >
                            <div className='position-relative card-image  ' >

                              <div className="text-end"  >
                                <Button variant="contained" sx={{ backgroundColor: "#92c323", '&:hover': { backgroundColor: "#76a521" } }} type="button" className=" update-btn " onClick={() => hanldeOpenDrawer(item._id, item.file_name, item.file_expiry, item.field_title, item.field_name, item.plate_number, item.pin_number, item.file_number)} >Update</Button>
                              </div>

                              {CheckExtension(item?.file_name) === "pdf" ? (
                                <PdfThumbnail
                                  className="card-img-top img-fluid card-image"
                                  onClick={() => handleOpenModal(item?.file_name)}
                                  style={{ height: 232, objectFit: "cover", cursor: "pointer" }}
                                  pdfUrl={String(item?.file_name || "").startsWith("http") ? item.file_name : `${IMAGES_URL}/${item?.file_name}`}
                                  fallbackSrc="/driver_forms/assets/images/pdf.png"
                                />
                              ) : (
                                <img
                                  className="card-img-top img-fluid card-image"
                                  onClick={() => handleOpenModal(item?.file_name)}
                                  style={{ height: 232, objectFit: "cover", cursor: "pointer" }}
                                  src={CheckExtension(item?.file_name) === "docx" ? "/driver_forms/assets/images/word.png" : `${item?.file_name}`}
                                  alt="Card cap"
                                />
                              )}
                            </div>

                            <ul className="list-group list-group-flush">
                              <li className="list-group-item" style={{ fontSize: 15, fontWeight: "bold" }} >
                                <div className='row' >
                                  <div className='col-12 d-flex align-items-center' style={{ textTransform: "capitalize" }} >
                                    {item?.field_title}
                                  </div>
                                </div>
                              </li>
                              {item.file_number && (
                                <li className="list-group-item">
                                  <div className='row' >
                                    <div className='col-6' >File Number</div>
                                    <div className='col-6 d-flex justify-content-end' >{item?.file_number}</div>
                                  </div>

                                </li>
                              )}
                              {item.field_name === "vehicle_reg" && (
                                <li className="list-group-item">
                                  <div className='row' >
                                    <div className='col-6' >Plate Number</div>
                                    <div className='col-6 d-flex justify-content-end' >{item?.plate_number}</div>
                                  </div>

                                </li>
                              )}
                              {item.field_name === "vehicle_reg" && (
                                <li className="list-group-item">
                                  <div className='row align-items-center ' >
                                    <div className='col-6' >Vin Number</div>
                                    <div className='col-6 d-flex justify-content-end' style={{ wordWrap: "anywhere" }} >{item?.pin_number}</div>
                                  </div>

                                </li>
                              )}
                              {item.file_expiry && (
                                <li className="list-group-item">
                                  <div className='row' >
                                    <div className='col-6' >File Expiry</div>
                                    <div className='col-6 d-flex justify-content-end' style={{ color: isExpired(item.file_expiry) ? "red" : "" }} >{FormatDate(item?.file_expiry)}</div>
                                  </div>

                                </li>
                              )}


                            </ul>
                          </Card>
                        </Grid>
                      ))}
                  </Grid>
                  :
                  user?.form_name === "partner_with_us" ?
                    <>
                      {partnerWithUsData.map((item) => (
                        <Box sx={{ border: "solid 1px #e1e1e1" }} >
                          <Grid container >
                            <Grid item xs={6} >
                              <Typography style={styles.details}>Institution</Typography>
                            </Grid>
                            <Grid item xs={6} textAlign={"end"} >
                              <Typography style={styles.value}>{item.institution_name}</Typography>
                            </Grid>
                          </Grid>
                          <Grid container >
                            <Grid item xs={6} >
                              <Typography style={styles.details}>Industry</Typography>
                            </Grid>
                            <Grid item xs={6} textAlign={"end"} >
                              <Typography style={styles.value}>{item.industry}</Typography>
                            </Grid>
                          </Grid>
                          <Grid container >
                            <Grid item xs={6} >
                              <Typography style={styles.details}>Other Industry</Typography>
                            </Grid>
                            <Grid item xs={6} textAlign={"end"} >
                              <Typography style={styles.value}>{item.other_industry}</Typography>
                            </Grid>
                          </Grid>
                          <Grid container >
                            <Grid item xs={6} >
                              <Typography style={styles.details}>Additional Info</Typography>
                            </Grid>
                            <Grid item xs={6} textAlign={"end"} >
                              <Typography style={styles.value}>{item.additional_info}</Typography>
                            </Grid>
                          </Grid>
                        </Box>

                      ))
                      }
                      {/* <Box px={5} pt={3} >
                  <Button onClick={hanldePartnerDrawer} fullWidth size="large" variant="contained" color="secondary">
                    {formBusy ? "Please wait...." : "Update"}
                  </Button>
                </Box> */}
                    </>
                    :
                    user?.form_name === "free_ride" ?
                      <>
                        {freeRideData.map((item) => (
                          <Box sx={{ border: "solid 1px #e1e1e1" }} >
                            <Grid container >
                              <Grid item xs={6} >
                                <Typography style={styles.details}>Patient Name</Typography>
                              </Grid>
                              <Grid item xs={6} textAlign={"end"} >
                                <Typography style={styles.value}>{item.patient_name}</Typography>
                              </Grid>
                            </Grid>
                            <Grid container >
                              <Grid item xs={6} >
                                <Typography style={styles.details}>Patient Age</Typography>
                              </Grid>
                              <Grid item xs={6} textAlign={"end"} >
                                <Typography style={styles.value}>{item.patient_age}</Typography>
                              </Grid>
                            </Grid>
                            <Grid container >
                              <Grid item xs={6} >
                                <Typography style={styles.details}>Patient Relation</Typography>
                              </Grid>
                              <Grid item xs={6} textAlign={"end"} >
                                <Typography style={styles.value}>{item.patient_relation}</Typography>
                              </Grid>
                            </Grid>
                            <Grid container >
                              <Grid item xs={6} >
                                <Typography style={styles.details}>Receiving Facility</Typography>
                              </Grid>
                              <Grid item xs={6} textAlign={"end"} >
                                <Typography style={styles.value}>{item.receiving_facility}</Typography>
                              </Grid>
                            </Grid>
                            <Grid container >
                              <Grid item xs={6} >
                                <Typography style={styles.details}>Transport Date</Typography>
                              </Grid>
                              <Grid item xs={6} textAlign={"end"} >
                                <Typography style={styles.value}>{formatDate(item.transport_date)}</Typography>
                              </Grid>
                            </Grid>
                            <Grid container >
                              <Grid item xs={6} >
                                <Typography style={styles.details}>Additional Info</Typography>
                              </Grid>
                              <Grid item xs={6} textAlign={"end"} >
                                <Typography style={styles.value}>{item.additional_info}</Typography>
                              </Grid>
                            </Grid>
                          </Box>


                        ))
                        }
                        {/* <Box px={5} pt={3} >
                  <Button onClick={hanldePartnerDrawer} fullWidth size="large" variant="contained" color="secondary">
                    {formBusy ? "Please wait...." : "Update"}
                  </Button>
                </Box> */}
                      </>
                      : null
                : value === 2 ?

                  <Box>

                    <PaymentComponent isMobile={false} driveWithUsData={driveWithUsData} setValue={setValue} />
                  </Box>


                  : value === 3 ?
                    <>
                      <Grid container spacing={2} p={2} >
                        <Grid item sm={12} md={12} lg={6} height={400} width={"100%"}  >
                          <Card className="h-100" elevation={5}  >
                            <div className="position-relative card-image " style={{ height: "40%" }} >
                              <img
                                src={getPreviewSrc(mobileData.fh1_prev, mobileData.fh1_pic)}
                                onClick={() => handlePreviewClick(mobileData.fh1_prev, mobileData.fh1_pic)}
                                className="card-img-top img-fluid card-image "
                                style={{ height: "100%", objectFit: "cover", cursor: "pointer" }}
                              />
                            </div>
                            <ul className="list-group list-group-flush">
                              <li className="list-group-item" style={{ fontSize: 15, fontWeight: "bold" }} >
                                <div className='row' >
                                  <div className='col-12 d-flex align-items-center' style={{ textTransform: "capitalize" }} >
                                    FH1 Insurance{carDataType === "new" && <span style={{ color: "red", marginLeft: "4px" }}>*</span>}
                                  </div>
                                </div>
                              </li>
                              <li className="list-group-item">
                                <Box sx={{ flexDirection: "column" }}   >
                                  <label style={{ color: "#000" }} >Fh1 Insurance</label>
                                  <Input invalid={mobileData.fh1Edit && mobileData.fh1_pic === ""} type="file" name="fh1" onChange={(e) => { selectMobileFile(e); setShowCarDataTypeRadio(true) }} />
                                  {mobileData.fh1Edit && mobileData.fh1_pic === "" && (
                                    <FormFeedback>Image is required</FormFeedback>
                                  )}
                                </Box>
                              </li>
                            </ul>

                          </Card>
                        </Grid>
                        <Grid item sm={12} md={12} lg={6} height={400} width={"100%"}  >
                          <Card className="h-100" elevation={5}  >
                            <div className="position-relative card-image " style={{ height: "40%" }} >
                              <img
                                src={getPreviewSrc(mobileData.laibility_insurance_prev, mobileData.laibility_insurance_pic)}
                                onClick={() => handlePreviewClick(mobileData.laibility_insurance_prev, mobileData.laibility_insurance_pic)}
                                className="card-img-top img-fluid card-image "
                                style={{ height: "100%", objectFit: "cover", cursor: "pointer" }}
                              />
                            </div>
                            <ul className="list-group list-group-flush">
                              <li className="list-group-item" style={{ fontSize: 15, fontWeight: "bold" }} >
                                <div className='row' >
                                  <div className='col-12 d-flex align-items-center' style={{ textTransform: "capitalize" }} >
                                    Liability Insurance{carDataType === "new" && <span style={{ color: "red", marginLeft: "4px" }}>*</span>}
                                  </div>
                                </div>
                              </li>
                              <li className="list-group-item">
                                <Box sx={{ flexDirection: "column" }}   >
                                  <label style={{ color: "#000" }} >Liability Insurance</label>
                                  <Input invalid={mobileData.laibility_insurance_edit && mobileData.laibility_insurance_pic === ""} helperText={mobileData.laibility_insurance_edit && mobileData.laibility_insurance_pic === "" ? "Image is required" : ""} type="file" name="liability_insurance" fullWidth onChange={(e) => selectMobileFile(e)} />
                                  {mobileData.laibility_insurance_edit && mobileData.laibility_insurance_pic === "" && (
                                    <FormFeedback>Image is required</FormFeedback>
                                  )}
                                </Box>
                              </li>
                              <li className="list-group-item">
                                <Box sx={{ flexDirection: "column" }}   >
                                  <label style={{ color: "#000" }} >
                                    Liability Insurance expiry{carDataType === "new" && <span style={{ color: "red", marginLeft: "4px" }}>*</span>}
                                  </label>
                                  <Input type="date" value={mobileData.laibility_insurance_expiry} onChange={(e) => {
                                    setMobileData((prev) => ({ ...prev, laibility_insurance_expiry: e.target.value, laibility_insurance_edit: true }))
                                  }} fullWidth />
                                </Box>
                              </li>
                            </ul>
                          </Card>

                        </Grid>
                        <Grid item sm={12} md={12} lg={6} height={550} width={"100%"} >
                          <Card className="h-100" elevation={5}  >

                            <div className="position-relative card-image " style={{ height: "40%" }} >
                              <img
                                src={getPreviewSrc(mobileData.dimond_sticker_prev, mobileData.dimond_sticker_pic)}
                                onClick={() => handlePreviewClick(mobileData.dimond_sticker_prev, mobileData.dimond_sticker_pic)}
                                className="card-img-top img-fluid card-image "
                                style={{ height: "100%", objectFit: "cover", cursor: "pointer" }}
                              />
                            </div>
                            <ul className="list-group list-group-flush">
                              <li className="list-group-item" style={{ fontSize: 15, fontWeight: "bold" }} >
                                <div className='row' >
                                  <div className='col-12 d-flex align-items-center' style={{ textTransform: "capitalize" }} >
                                    Diamond sticker{carDataType === "new" && <span style={{ color: "red", marginLeft: "4px" }}>*</span>}
                                  </div>
                                </div>
                              </li>
                              <li className="list-group-item">
                                <Box sx={{ flexDirection: "column" }}   >
                                  <label style={{ color: "#000" }} >Diamond sticker</label>
                                  <Input invalid={mobileData.dimond_sticker_edit && mobileData.dimond_sticker_pic === ""} type="file" name="diamond_sticker" onChange={(e) => selectMobileFile(e)} />
                                  {mobileData.dimond_sticker_edit && mobileData.dimond_sticker_pic === "" && (
                                    <FormFeedback>Image is required</FormFeedback>
                                  )}
                                </Box>
                              </li>
                              <li className="list-group-item">
                                <Box sx={{ flexDirection: "column" }}   >
                                  <label style={{ color: "#000" }} >
                                    Diamond sticker expiry{carDataType === "new" && <span style={{ color: "red", marginLeft: "4px" }}>*</span>}
                                  </label>
                                  <Input type="date" value={mobileData.dimond_sticker_expiry} onChange={(e) => {
                                    setMobileData((prev) => ({ ...prev, dimond_sticker_expiry: e.target.value, dimond_sticker_edit: true }))
                                  }} />
                                </Box>
                              </li>
                              <li className="list-group-item">
                                <Box sx={{ flexDirection: "column" }}   >
                                  <label style={{ color: "#000" }} > Diamond sticker Number </label>
                                  <Input type="text" value={mobileData.dimond_sticker_number} onChange={(e) => {
                                    setMobileData((prev) => ({ ...prev, dimond_sticker_number: e.target.value, dimond_sticker_edit: true }))
                                  }} />
                                </Box>
                              </li>
                            </ul>



                          </Card>

                        </Grid>
                        <Grid item sm={12} md={12} lg={6} height={550} width={"100%"} >
                          <Card className="h-100" elevation={5}  >

                            <div className="position-relative card-image " style={{ height: "40%" }} >
                              <img
                                src={getPreviewSrc(mobileData.car_inspection_prev, mobileData.car_inspection_pic)}
                                onClick={() => handlePreviewClick(mobileData.car_inspection_prev, mobileData.car_inspection_pic)}
                                className="card-img-top img-fluid card-image "
                                style={{ height: "100%", objectFit: "cover", cursor: "pointer" }}
                              />
                            </div>
                            <ul className="list-group list-group-flush">
                              <li className="list-group-item" style={{ fontSize: 15, fontWeight: "bold" }} >
                                <div className='row' >
                                  <div className='col-12 d-flex align-items-center' style={{ textTransform: "capitalize" }} >
                                    Car inspection{carDataType === "new" && <span style={{ color: "red", marginLeft: "4px" }}>*</span>}
                                  </div>
                                </div>
                              </li>
                              <li className="list-group-item">
                                <Box sx={{ flexDirection: "column" }}   >
                                  <label style={{ color: "#000" }} >Car inspection</label>
                                  <Input invalid={mobileData.car_inspection_edit && mobileData.car_inspection_pic === ""} type="file" name="car_inspection" onChange={(e) => selectMobileFile(e)} />
                                  {mobileData.car_inspection_edit && mobileData.car_inspection_pic === "" && (
                                    <FormFeedback>Image is required</FormFeedback>
                                  )}
                                </Box>
                              </li>
                              <li className="list-group-item">
                                <Box sx={{ flexDirection: "column" }}   >
                                  <label style={{ color: "#000" }} >
                                    Car inspection expiry{carDataType === "new" && <span style={{ color: "red", marginLeft: "4px" }}>*</span>}{mobileData.car_inspection_expiry ? `  — Expires: ${getEffectiveCarInspectionExpiryDisplay(mobileData.car_inspection_expiry)}` : ""}
                                  </label>
                                  <Input type="date" value={mobileData.car_inspection_expiry} onChange={(e) => {
                                    setMobileData((prev) => ({ ...prev, car_inspection_expiry: e.target.value, car_inspection_edit: true }))
                                  }} />
                                </Box>
                              </li>
                            </ul>


                          </Card>
                        </Grid>
                        <Grid item sm={12} md={12} lg={6} height={650} width={"100%"}  >
                          <Card className="h-100" elevation={5}  >

                            <div className="position-relative card-image " style={{ height: "40%" }} >
                              <img
                                src={getPreviewSrc(mobileData.vehicle_reg_prev, mobileData.vehicle_reg_pic)}
                                onClick={() => handlePreviewClick(mobileData.vehicle_reg_prev, mobileData.vehicle_reg_pic)}
                                className="card-img-top img-fluid card-image "
                                style={{ height: "100%", objectFit: "cover", cursor: "pointer" }}
                              />
                            </div>
                            <ul className="list-group list-group-flush">
                              <li className="list-group-item" style={{ fontSize: 15, fontWeight: "bold" }} >
                                <div className='row' >
                                  <div className='col-12 d-flex align-items-center' style={{ textTransform: "capitalize" }} >
                                    Vehicle reg{carDataType === "new" && <span style={{ color: "red", marginLeft: "4px" }}>*</span>}
                                  </div>
                                </div>
                              </li>
                              <li className="list-group-item">
                                <Box sx={{ flexDirection: "column" }}   >
                                  <label style={{ color: "#000" }} >Vehicle reg</label>
                                  <Input invalid={mobileData.vehicle_reg_edit && mobileData.vehicle_reg_pic === ""} type="file" name="vehicle_reg" onChange={(e) => selectMobileFile(e)} />
                                  {mobileData.vehicle_reg_edit && mobileData.vehicle_reg_pic === "" && (
                                    <FormFeedback>Image is required</FormFeedback>
                                  )}
                                </Box>
                              </li>
                              <li className="list-group-item">
                                <Box sx={{ flexDirection: "column" }}   >
                                  <label style={{ color: "#000" }} >
                                    Vehicle reg expiry{carDataType === "new" && <span style={{ color: "red", marginLeft: "4px" }}>*</span>}
                                  </label>
                                  <Input type="date" value={mobileData.vehicle_reg_expiry} onChange={(e) => {
                                    setMobileData((prev) => ({ ...prev, vehicle_reg_expiry: e.target.value, vehicle_reg_edit: true }))
                                  }} fullWidth />
                                </Box>
                              </li>
                              <li className="list-group-item">
                                <Box sx={{ flexDirection: "column" }}   >
                                  <label style={{ color: "#000" }} >
                                    Plate Number{carDataType === "new" && <span style={{ color: "red", marginLeft: "4px" }}>*</span>}
                                  </label>
                                  <Input type="text" value={mobileData.plate_number} onChange={(e) => {
                                    setMobileData((prev) => ({ ...prev, plate_number: e.target.value, vehicle_reg_edit: true }))
                                  }} fullWidth />
                                </Box>
                              </li>
                              <li className="list-group-item">
                                <Box sx={{ flexDirection: "column" }}   >
                                  <label style={{ color: "#000" }} >
                                    Vin Number{carDataType === "new" && <span style={{ color: "red", marginLeft: "4px" }}>*</span>}
                                  </label>
                                  <Input type="text" value={vinNumber !== "" ? vinNumber : mobileData.vin_number} onChange={(e) => {
                                    setVinNumber(e.target.value); setMobileData((prev) => ({ ...prev, vehicle_reg_edit: true, laibility_insurance_edit: true, dimond_sticker_edit: true, car_inspection_edit: true, vehicle_edit: true, vehicle_reg_edit: true, fh1Edit: true }))
                                  }} fullWidth />
                                </Box>
                              </li>
                            </ul>
                          </Card>
                        </Grid>
                        <Grid item sm={12} md={12} lg={6} height={650} width={"100%"} >
                          <Card className="h-100" elevation={5}  >

                            <div className="position-relative card-image " style={{ height: "40%" }} >
                              <img
                                src={getPreviewSrc(mobileData.vehicle_prev, mobileData.vehicle_pic)}
                                onClick={() => handlePreviewClick(mobileData.vehicle_prev, mobileData.vehicle_pic)}
                                className="card-img-top img-fluid card-image "
                                style={{ height: "100%", objectFit: "cover", cursor: "pointer" }}
                              />
                            </div>
                            <ul className="list-group list-group-flush">
                              <li className="list-group-item" style={{ fontSize: 15, fontWeight: "bold" }} >
                                <div className='row' >
                                  <div className='col-12 d-flex align-items-center' style={{ textTransform: "capitalize" }} >
                                    Vehicle pic{carDataType === "new" && <span style={{ color: "red", marginLeft: "4px" }}>*</span>}
                                  </div>
                                </div>
                              </li>
                              <li className="list-group-item">
                                <Box sx={{ flexDirection: "column" }}   >
                                  <label style={{ color: "#000" }} >Vehicle pic</label>
                                  <Input invalid={mobileData.vehicle_edit && mobileData.vehicle_pic === ""} type="file" name="vehicle_pic" onChange={(e) => selectMobileFile(e)} />
                                  {mobileData.vehicle_edit && mobileData.vehicle_pic === "" && (
                                    <FormFeedback>Image is required</FormFeedback>
                                  )}
                                </Box>
                              </li>
                            </ul>
                          </Card>
                        </Grid>

                      </Grid>

                      {showCarDataTypeRadio && (
                        <Box px={5} pt={3} pb={2}>
                          <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold", color: "#021b38" }}>
                            Car Data Type *
                          </Typography>
                          <Box sx={{ display: "flex", gap: 3, alignItems: "center" }}>
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                              <input
                                type="radio"
                                id="newCar-desktop"
                                name="carDataType-desktop"
                                value="new"
                                checked={carDataType === "new"}
                                onChange={(e) => setCarDataType(e.target.value)}
                                style={{
                                  marginRight: "8px",
                                  accentColor: "#97c11f",
                                  transform: "scale(1.2)"
                                }}
                              />
                              <label htmlFor="newCar-desktop" style={{ cursor: "pointer", fontWeight: "500", color: "#97c11f" }}>
                                New Car Data
                              </label>
                            </Box>
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                              <input
                                type="radio"
                                id="oldCar-desktop"
                                name="carDataType-desktop"
                                value="old"
                                checked={carDataType === "old"}
                                onChange={(e) => setCarDataType(e.target.value)}
                                style={{
                                  marginRight: "8px",
                                  accentColor: "#97c11f",
                                  transform: "scale(1.2)"
                                }}
                              />
                              <label htmlFor="oldCar-desktop" style={{ cursor: "pointer", fontWeight: "500", color: "#97c11f" }}>
                                Old Car Data
                              </label>
                            </Box>
                          </Box>
                          {!carDataType && (
                            <Typography variant="body2" sx={{ color: "red", mt: 1 }}>
                              Please select a car data type
                            </Typography>
                          )}
                          {carDataType === "new" && (
                            <Typography variant="body2" sx={{ color: "#97c11f", mt: 1, fontWeight: "500" }}>
                              ⚠️ All fields are required for new car data
                            </Typography>
                          )}
                        </Box>
                      )}

                      <Box px={5} pt={3} pb={5} >
                        <Button sx={{ backgroundColor: "#021b38", '&:hover': { backgroundColor: "#76a521" } }} onClick={handleMobileUpdate} size="large" variant="contained" color="secondary">
                          {formBusy ? "Please wait...." : "Update"}
                        </Button>
                      </Box>
                    </>

                    : null}
            </CardContent>
            <CardContent
              sx={{
                p: 3,

                textAlign: { md: "start" },
                display: { xs: "block", md: "none" }

              }}
            >
              {value === 3 ?
                user?.form_name === "drive_with_us" ?
                  <Box height={""} >
                    <IconButton onClick={() => setValue(0)} sx={{ backgroundColor: "#021b38", m: 2, px: 3, color: "#FFF", borderRadius: 2, '&:hover': { backgroundColor: "#021b38" } }} variant="contained" size="icon" className="d-flex d-md-none"   >
                      <FontAwesomeIcon icon={faChevronLeft} />
                    </IconButton>
                    <Grid container spacing={2} p={2} >

                      {driveWithUsData
                        .filter((item) => isExpired(item.file_expiry) || item.file_status === 2)
                        .map((item) => (

                          <Grid item xs={12} lg={4} key={item._id} >
                            {/* <Card elevation={4} sx={{ height: "100%", width: "100%" }} >
                          <Grid container mt={3}  >
                            <Grid xs={12} justifyContent={"space-around"} alignItems={"center"} flexDirection={"column"} display={"flex"}  >
                              <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"} width={"100%"} spacing={2} px={1} mb={2}  >
                                {RenderStatus(String(item.file_status))}
                                <Button sx={{ color: "#92c323" }} size="small" onClick={() => hanldeOpenDrawer(item._id, item.file_name, item.file_expiry, item.field_title, item.field_name, item.plate_number, item.pin_number, item.file_number)} >Update File</Button>

                              </Stack>

                              <Typography fontWeight={900} fontSize={12} mb={1} >{item.field_title}</Typography>
                              {item.file_number && item.file_number !== "undefined" && (
                                <Typography mb={1} fontSize={14} >{item.file_number}</Typography>
                              )}
                              {item.field_name === "vehicle_reg" ?
                                <Stack direction={"row"} justifyContent={"space-between"} width="100%" alignItems={"center"}  >

                                  <Box width="100%" textAlign={"center"} >
                                    <Typography fontSize={14} fontWeight={700} >Plate Number</Typography>
                                    <Typography fontSize={12} >{item.plate_number}</Typography>
                                  </Box>
                                  <img onClick={() => handleOpenModal(item.file_name)} style={{ height: 150, width: 150, cursor: "pointer" }} src={CheckExtension(item.file_name) === "pdf" ? "/driver_forms/assets/images/pdf.png" : CheckExtension(item.file_name) === "docx" ? "/driver_forms/assets/images/word.png" : `${item.file_name}`} />
                                  <Box width="100%" textAlign={"center"} >
                                    <Typography fontSize={14} fontWeight={700} >Vin Number</Typography>
                                    <Typography fontSize={12} >{item.pin_number}</Typography>
                                  </Box>
                                </Stack>
                                :
                                <img onClick={() => handleOpenModal(item.file_name)} style={{ height: 150, width: 150, cursor: "pointer" }} src={CheckExtension(item.file_name) === "pdf" ? "/driver_forms/assets/images/pdf.png" : CheckExtension(item.file_name) === "docx" ? "/driver_forms/assets/images/word.png" : `${item.file_name}`} />
                              }
                              
                            </Grid>
                            {item.file_expiry && (
                              <Grid xs={12} display={"flex"} flexDirection={"column"} alignItems={"center"} justifyContent={"space-evenly"}  >
                                <Typography mt={2} fontSize={12} fontWeight={900} >Expiry</Typography>
                                <Typography mt={2} mb={2} color={isExpired(item.file_expiry) ? "red" : "black"} >{FormatDate(item.file_expiry)}</Typography>
                              </Grid>
                            )}


                          </Grid>
                        </Card> */}
                            <Card className="h-100" elevation={5}  >
                              <div className='position-relative card-image  ' >

                                <div className="text-end"  >
                                  <Button variant="contained" sx={{ backgroundColor: "#021b38", '&:hover': { backgroundColor: "#76a521" } }} type="button" className=" update-btn " onClick={() => hanldeOpenDrawer(item._id, item.file_name, item.file_expiry, item.field_title, item.field_name, item.plate_number, item.pin_number, item.file_number)} >Update</Button>
                                </div>

                                {CheckExtension(item?.file_name) === "pdf" ? (
                                <PdfThumbnail
                                  className="card-img-top img-fluid card-image"
                                  onClick={() => handleOpenModal(item?.file_name)}
                                  style={{ height: 232, objectFit: "cover", cursor: "pointer" }}
                                  pdfUrl={String(item?.file_name || "").startsWith("http") ? item.file_name : `${IMAGES_URL}/${item?.file_name}`}
                                  fallbackSrc="/driver_forms/assets/images/pdf.png"
                                />
                              ) : (
                                <img
                                  className="card-img-top img-fluid card-image"
                                  onClick={() => handleOpenModal(item?.file_name)}
                                  style={{ height: 232, objectFit: "cover", cursor: "pointer" }}
                                  src={CheckExtension(item?.file_name) === "docx" ? "/driver_forms/assets/images/word.png" : `${item?.file_name}`}
                                  alt="Card cap"
                                />
                              )}
                              </div>

                              <ul className="list-group list-group-flush">
                                <li className="list-group-item" style={{ fontSize: 15, fontWeight: "bold" }} >
                                  <div className='row' >
                                    <div className='col-12 d-flex align-items-center' style={{ textTransform: "capitalize" }} >
                                      {item?.field_title}
                                    </div>
                                  </div>
                                </li>
                                {item.file_number && (
                                  <li className="list-group-item">
                                    <div className='row' >
                                      <div className='col-6' >File Number</div>
                                      <div className='col-6 d-flex justify-content-end' >{item?.file_number}</div>
                                    </div>

                                  </li>
                                )}
                                {item.field_name === "vehicle_reg" && (
                                  <li className="list-group-item">
                                    <div className='row' >
                                      <div className='col-6' >Plate Number</div>
                                      <div className='col-6 d-flex justify-content-end' >{item?.plate_number}</div>
                                    </div>

                                  </li>
                                )}
                                {item.field_name === "vehicle_reg" && (
                                  <li className="list-group-item">
                                    <div className='row align-items-center ' >
                                      <div className='col-6' >Vin Number</div>
                                      <div className='col-6 d-flex justify-content-end' style={{ wordWrap: "anywhere" }} >{item?.pin_number}</div>
                                    </div>

                                  </li>
                                )}
                                {item.file_expiry && (
                                  <li className="list-group-item">
                                    <div className='row' >
                                      <div className='col-6' >File Expiry</div>
                                      <div className='col-6 d-flex justify-content-end' style={{ color: isExpired(item.file_expiry) ? "red" : "" }} >{FormatDate(item?.file_expiry)}</div>
                                    </div>

                                  </li>
                                )}


                              </ul>
                            </Card>
                          </Grid>
                        ))}
                    </Grid>
                  </Box>
                  :
                  user?.form_name === "partner_with_us" ?
                    <>
                      {partnerWithUsData.map((item) => (
                        <Box sx={{ border: "solid 1px #e1e1e1" }} >
                          <Grid container >
                            <Grid item xs={6} >
                              <Typography style={styles.details}>Institution</Typography>
                            </Grid>
                            <Grid item xs={6} textAlign={"end"} >
                              <Typography style={styles.value}>{item.institution_name}</Typography>
                            </Grid>
                          </Grid>
                          <Grid container >
                            <Grid item xs={6} >
                              <Typography style={styles.details}>Industry</Typography>
                            </Grid>
                            <Grid item xs={6} textAlign={"end"} >
                              <Typography style={styles.value}>{item.industry}</Typography>
                            </Grid>
                          </Grid>
                          <Grid container >
                            <Grid item xs={6} >
                              <Typography style={styles.details}>Other Industry</Typography>
                            </Grid>
                            <Grid item xs={6} textAlign={"end"} >
                              <Typography style={styles.value}>{item.other_industry}</Typography>
                            </Grid>
                          </Grid>
                          <Grid container >
                            <Grid item xs={6} >
                              <Typography style={styles.details}>Additional Info</Typography>
                            </Grid>
                            <Grid item xs={6} textAlign={"end"} >
                              <Typography style={styles.value}>{item.additional_info}</Typography>
                            </Grid>
                          </Grid>
                        </Box>

                      ))
                      }
                      {/* <Box px={5} pt={3} >
                  <Button onClick={hanldePartnerDrawer} fullWidth size="large" variant="contained" color="secondary">
                    {formBusy ? "Please wait...." : "Update"}
                  </Button>
                </Box> */}
                    </>
                    :
                    user?.form_name === "free_ride" ?
                      <>
                        {freeRideData.map((item) => (
                          <Box sx={{ border: "solid 1px #e1e1e1" }} >
                            <Grid container >
                              <Grid item xs={6} >
                                <Typography style={styles.details}>Patient Name</Typography>
                              </Grid>
                              <Grid item xs={6} textAlign={"end"} >
                                <Typography style={styles.value}>{item.patient_name}</Typography>
                              </Grid>
                            </Grid>
                            <Grid container >
                              <Grid item xs={6} >
                                <Typography style={styles.details}>Patient Age</Typography>
                              </Grid>
                              <Grid item xs={6} textAlign={"end"} >
                                <Typography style={styles.value}>{item.patient_age}</Typography>
                              </Grid>
                            </Grid>
                            <Grid container >
                              <Grid item xs={6} >
                                <Typography style={styles.details}>Patient Relation</Typography>
                              </Grid>
                              <Grid item xs={6} textAlign={"end"} >
                                <Typography style={styles.value}>{item.patient_relation}</Typography>
                              </Grid>
                            </Grid>
                            <Grid container >
                              <Grid item xs={6} >
                                <Typography style={styles.details}>Receiving Facility</Typography>
                              </Grid>
                              <Grid item xs={6} textAlign={"end"} >
                                <Typography style={styles.value}>{item.receiving_facility}</Typography>
                              </Grid>
                            </Grid>
                            <Grid container >
                              <Grid item xs={6} >
                                <Typography style={styles.details}>Transport Date</Typography>
                              </Grid>
                              <Grid item xs={6} textAlign={"end"} >
                                <Typography style={styles.value}>{formatDate(item.transport_date)}</Typography>
                              </Grid>
                            </Grid>
                            <Grid container >
                              <Grid item xs={6} >
                                <Typography style={styles.details}>Additional Info</Typography>
                              </Grid>
                              <Grid item xs={6} textAlign={"end"} >
                                <Typography style={styles.value}>{item.additional_info}</Typography>
                              </Grid>
                            </Grid>
                          </Box>


                        ))
                        }
                        {/* <Box px={5} pt={3} >
                  <Button onClick={hanldePartnerDrawer} fullWidth size="large" variant="contained" color="secondary">
                    {formBusy ? "Please wait...." : "Update"}
                  </Button>
                </Box> */}
                      </>
                      : null
                : value === 2 ?

                  <Box>

                    <PaymentComponent isMobile={false} driveWithUsData={driveWithUsData} />
                  </Box>


                  : value === 4 ?
                    <>
                      <IconButton onClick={() => setValue(0)} sx={{ backgroundColor: "#021b38", m: 2, px: 3, color: "#FFF", borderRadius: 2, '&:hover': { backgroundColor: "#021b38" } }} variant="contained" size="icon" className="d-flex d-md-none"   >
                        <FontAwesomeIcon icon={faChevronLeft} />
                      </IconButton>
                      <Grid container spacing={6} p={2}  >
                        <Grid item sm={12} md={12} lg={6} width={"100%"}    >
                          <Card className="h-auto h-md-100 pb-4 pb-lg-0 " elevation={5}   >
                            <div className="position-relative card-image " style={{ height: window.innerWidth > 768 ? "40%" : "200px" }} >
                              <img
                                src={getPreviewSrc(mobileData.fh1_prev, mobileData.fh1_pic)}
                                onClick={() => handlePreviewClick(mobileData.fh1_prev, mobileData.fh1_pic)}
                                className="card-img-top img-fluid card-image "
                                style={{ height: "100%", objectFit: "cover", cursor: "pointer" }}
                              />
                            </div>
                            <ul className="list-group list-group-flush">
                              <li className="list-group-item" style={{ fontSize: 15, fontWeight: "bold" }} >
                                <div className='row' >
                                  <div className='col-12 d-flex align-items-center' style={{ textTransform: "capitalize" }} >
                                    FH1 Insurance
                                  </div>
                                </div>
                              </li>
                              <li className="list-group-item">
                                <Box sx={{ flexDirection: "column" }}   >
                                  {/* <label style={{ color: "#000" }} >Fh1 Insurance</label> */}
                                  {/* <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      border: '1px solid #dcdcdc',
                                      borderRadius: '10px',
                                      overflow: 'hidden',
                                      width: '100%',
                                      cursor: 'pointer'
                                    }}
                                    onClick={handleClick}
                                  >
                                    <div
                                      style={{
                                        backgroundColor: '#a3cc00',
                                        padding: '12px 20px',
                                        display: 'flex',
                                        alignItems: 'center'
                                      }}
                                    >
                                      <FaCloudUploadAlt size={18} color="white" />
                                    </div>
                                    <div style={{ padding: '5px 20px' }}>
                                      <span style={{ fontSize: '16px' }}>Upload File</span>
                                    </div>
                                  </div>

                                  <Input
                                    innerRef={fileInputRef}
                                    type="file"
                                    name="fh1"
                                    onChange={(e) => selectMobileFile(e)}
                                    invalid={mobileData.fh1Edit && mobileData.fh1_pic === ""}
                                    style={{ display: 'none' }}
                                  /> */}
                                  <FileUploadField
                                    label="Fh1 Insurance"
                                    name="fh1"
                                    fileUrl={mobileData.fh1_prev}
                                    fileValue={mobileData.fh1_pic}
                                    showError={mobileData.fh1Edit}
                                    onChange={selectMobileFile}
                                  />
                                  {/* <Input invalid={mobileData.fh1Edit && mobileData.fh1_pic === ""} type="file" name="fh1" onChange={(e) => selectMobileFile(e)} /> */}
                                  {mobileData.fh1Edit && mobileData.fh1_pic === "" && (
                                    <FormFeedback>Image is required</FormFeedback>
                                  )}
                                </Box>
                              </li>
                            </ul>

                          </Card>
                        </Grid>
                        <Grid item sm={12} md={12} lg={6} width={"100%"}  >
                          <Card className="h-auto h-md-100 pb-4 pb-lg-0" elevation={5}   >
                            <div className="position-relative card-image " style={{ height: window.innerWidth > 768 ? "40%" : "200px" }} >
                              <img
                                src={getPreviewSrc(mobileData.laibility_insurance_prev, mobileData.laibility_insurance_pic)}
                                onClick={() => handlePreviewClick(mobileData.laibility_insurance_prev, mobileData.laibility_insurance_pic)}
                                className="card-img-top img-fluid card-image "
                                style={{ height: "100%", objectFit: "cover", cursor: "pointer" }}
                              />
                            </div>
                            <ul className="list-group list-group-flush">
                              <li className="list-group-item" style={{ fontSize: 15, fontWeight: "bold" }} >
                                <div className='row' >
                                  <div className='col-12 d-flex align-items-center' style={{ textTransform: "capitalize" }} >
                                    Liability Insurance
                                  </div>
                                </div>
                              </li>
                              <li className="list-group-item">
                                <Box sx={{ flexDirection: "column" }}   >
                                  <FileUploadField
                                    label="Liability Insurance"
                                    name="liability_insurance"
                                    fileUrl={mobileData.laibility_insurance_prev}
                                    fileValue={mobileData.laibility_insurance_pic}
                                    showError={mobileData.laibility_insurance_edit}
                                    onChange={selectMobileFile}
                                  />
                                  {/* <label style={{ color: "#000" }} >Liability Insurance</label>
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      border: '1px solid #dcdcdc',
                                      borderRadius: '10px',
                                      overflow: 'hidden',
                                      width: '100%',
                                      cursor: 'pointer'
                                    }}
                                    onClick={handleClick}
                                  >
                                    <div
                                      style={{
                                        backgroundColor: '#a3cc00',
                                        padding: '12px 20px',
                                        display: 'flex',
                                        alignItems: 'center'
                                      }}
                                    >
                                      <FaCloudUploadAlt size={18} color="white" />
                                    </div>
                                    <div style={{ padding: '5px 20px' }}>
                                      <span style={{ fontSize: '16px' }}>Upload File</span>
                                    </div>
                                  </div>

                                  <Input
                                    innerRef={fileInputRef}
                                    type="file"
                                    name="liability_insurance"
                                    onChange={(e) => selectMobileFile(e)}
                                    invalid={mobileData.laibility_insurance_edit && mobileData.laibility_insurance_pic === ""}
                                    style={{ display: 'none' }}
                                  /> */}
                                  {/* <Input invalid={mobileData.laibility_insurance_edit && mobileData.laibility_insurance_pic === ""} helperText={mobileData.laibility_insurance_edit && mobileData.laibility_insurance_pic === "" ? "Image is required" : ""} type="file" name="liability_insurance" fullWidth onChange={(e) => selectMobileFile(e)} /> */}
                                  {/* {mobileData.laibility_insurance_edit && mobileData.laibility_insurance_pic === "" && (
                                    <FormFeedback>Image is required</FormFeedback>
                                  )} */}
                                </Box>
                              </li>
                              <li className="list-group-item">
                                <Box sx={{ flexDirection: "column" }}   >
                                  <label style={{ color: "#000" }} >Liability Insurance expiry </label>
                                  <Input type="date" value={mobileData.laibility_insurance_expiry} onChange={(e) => {
                                    setMobileData((prev) => ({ ...prev, laibility_insurance_expiry: e.target.value, laibility_insurance_edit: true }))
                                  }} fullWidth />
                                </Box>
                              </li>
                            </ul>
                          </Card>

                        </Grid>
                        <Grid item sm={12} md={12} lg={6} width={"100%"}  >
                          <Card className="h-auto h-md-100 pb-4 pb-lg-0" elevation={5}  >

                            <div className="position-relative card-image " style={{ height: window.innerWidth > 768 ? "40%" : "200px" }} >
                              <img
                                src={getPreviewSrc(mobileData.dimond_sticker_prev, mobileData.dimond_sticker_pic)}
                                onClick={() => handlePreviewClick(mobileData.dimond_sticker_prev, mobileData.dimond_sticker_pic)}
                                className="card-img-top img-fluid card-image "
                                style={{ height: "100%", objectFit: "cover", cursor: "pointer" }}
                              />
                            </div>
                            <ul className="list-group list-group-flush">
                              <li className="list-group-item" style={{ fontSize: 15, fontWeight: "bold" }} >
                                <div className='row' >
                                  <div className='col-12 d-flex align-items-center' style={{ textTransform: "capitalize" }} >
                                    Diamond sticker
                                  </div>
                                </div>
                              </li>
                              <li className="list-group-item">
                                <Box sx={{ flexDirection: "column" }}   >
                                  <FileUploadField
                                    label="Diamond sticker"
                                    name="diamond_sticker"
                                    fileUrl={mobileData.dimond_sticker_prev}
                                    fileValue={mobileData.dimond_sticker_pic}
                                    showError={mobileData.dimond_sticker_edit}
                                    onChange={selectMobileFile}
                                  />
                                  {/* <label style={{ color: "#000" }} >Diamond sticker</label>

                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      border: '1px solid #dcdcdc',
                                      borderRadius: '10px',
                                      overflow: 'hidden',
                                      width: '100%',
                                      cursor: 'pointer'
                                    }}
                                    onClick={handleClick}
                                  >
                                    <div
                                      style={{
                                        backgroundColor: '#a3cc00',
                                        padding: '12px 20px',
                                        display: 'flex',
                                        alignItems: 'center'
                                      }}
                                    >
                                      <FaCloudUploadAlt size={18} color="white" />
                                    </div>
                                    <div style={{ padding: '5px 20px' }}>
                                      <span style={{ fontSize: '16px' }}>Upload File</span>
                                    </div>
                                  </div>

                                  <Input
                                    innerRef={fileInputRef}
                                    type="file"
                                    name="diamond_sticker"
                                    onChange={(e) => selectMobileFile(e)}
                                    invalid={mobileData.dimond_sticker_edit && mobileData.dimond_sticker_pic === ""}
                                    style={{ display: 'none' }}
                                  /> */}
                                  {/* <Input invalid={mobileData.dimond_sticker_edit && mobileData.dimond_sticker_pic === ""} type="file" name="diamond_sticker" onChange={(e) => selectMobileFile(e)} /> */}
                                  {/* {mobileData.dimond_sticker_edit && mobileData.dimond_sticker_pic === "" && (
                                    <FormFeedback>Image is required</FormFeedback>
                                  )} */}
                                </Box>
                              </li>
                              <li className="list-group-item">
                                <Box sx={{ flexDirection: "column" }}   >
                                  <label style={{ color: "#000" }} >Diamond sticker expiry </label>
                                  <Input type="date" value={mobileData.dimond_sticker_expiry} onChange={(e) => {
                                    setMobileData((prev) => ({ ...prev, dimond_sticker_expiry: e.target.value, dimond_sticker_edit: true }))
                                  }} />
                                </Box>
                              </li>
                              <li className="list-group-item">
                                <Box sx={{ flexDirection: "column" }}   >
                                  <label style={{ color: "#000" }} > Diamond sticker Number </label>
                                  <Input type="text" value={mobileData.dimond_sticker_number} onChange={(e) => {
                                    setMobileData((prev) => ({ ...prev, dimond_sticker_number: e.target.value, dimond_sticker_edit: true }))
                                  }} />
                                </Box>
                              </li>
                            </ul>



                          </Card>

                        </Grid>
                        <Grid item sm={12} md={12} lg={6} width={"100%"}  >
                          <Card className="h-auto h-md-100 pb-4 pb-lg-0" elevation={5}  >

                            <div className="position-relative card-image " style={{ height: window.innerWidth > 768 ? "40%" : "200px" }} >
                              <img
                                src={getPreviewSrc(mobileData.car_inspection_prev, mobileData.car_inspection_pic)}
                                onClick={() => handlePreviewClick(mobileData.car_inspection_prev, mobileData.car_inspection_pic)}
                                className="card-img-top img-fluid card-image "
                                style={{ height: "100%", objectFit: "cover", cursor: "pointer" }}
                              />
                            </div>
                            <ul className="list-group list-group-flush">
                              <li className="list-group-item" style={{ fontSize: 15, fontWeight: "bold" }} >
                                <div className='row' >
                                  <div className='col-12 d-flex align-items-center' style={{ textTransform: "capitalize" }} >
                                    Car inspection
                                  </div>
                                </div>
                              </li>
                              <li className="list-group-item">
                                <Box sx={{ flexDirection: "column" }}   >
                                  <FileUploadField
                                    label="Car inspection"
                                    name="car_inspection"
                                    fileUrl={mobileData.car_inspection_prev}
                                    fileValue={mobileData.car_inspection_pic}
                                    showError={mobileData.car_inspection_edit}
                                    onChange={selectMobileFile}
                                  />
                                  {/* <label style={{ color: "#000" }} >Car inspection</label>
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      border: '1px solid #dcdcdc',
                                      borderRadius: '10px',
                                      overflow: 'hidden',
                                      width: '100%',
                                      cursor: 'pointer'
                                    }}
                                    onClick={handleClick}
                                  >
                                    <div
                                      style={{
                                        backgroundColor: '#a3cc00',
                                        padding: '12px 20px',
                                        display: 'flex',
                                        alignItems: 'center'
                                      }}
                                    >
                                      <FaCloudUploadAlt size={18} color="white" />
                                    </div>
                                    <div style={{ padding: '5px 20px' }}>
                                      <span style={{ fontSize: '16px' }}>Upload File</span>
                                    </div>
                                  </div>

                                  <Input
                                    innerRef={fileInputRef}
                                    type="file"
                                    name="car_inspection"
                                    onChange={(e) => selectMobileFile(e)}
                                    invalid={mobileData.car_inspection_edit && mobileData.car_inspection_pic === ""}
                                    style={{ display: 'none' }}
                                  /> */}
                                  {/* <Input invalid={mobileData.car_inspection_edit && mobileData.car_inspection_pic === ""} type="file" name="car_inspection" onChange={(e) => selectMobileFile(e)} /> */}
                                  {/* {mobileData.car_inspection_edit && mobileData.car_inspection_pic === "" && (
                                    <FormFeedback>Image is required</FormFeedback>
                                  )} */}
                                </Box>
                              </li>
                              <li className="list-group-item">
                                <Box sx={{ flexDirection: "column" }}   >
                                  <label style={{ color: "#000" }} >Car inspection expiry{mobileData.car_inspection_expiry ? `  — Expires: ${getEffectiveCarInspectionExpiryDisplay(mobileData.car_inspection_expiry)}` : ""}</label>

                                  <Input type="date" value={mobileData.car_inspection_expiry} onChange={(e) => {
                                    setMobileData((prev) => ({ ...prev, car_inspection_expiry: e.target.value, car_inspection_edit: true }))
                                  }} />
                                </Box>
                              </li>
                            </ul>


                          </Card>
                        </Grid>
                        <Grid item sm={12} md={12} lg={6} width={"100%"}  >
                          <Card className="h-auto h-md-100 pb-4 pb-lg-0" elevation={5}  >

                            <div className="position-relative card-image " style={{ height: window.innerWidth > 768 ? "40%" : "200px" }} >
                              <img
                                src={getPreviewSrc(mobileData.vehicle_reg_prev, mobileData.vehicle_reg_pic)}
                                onClick={() => handlePreviewClick(mobileData.vehicle_reg_prev, mobileData.vehicle_reg_pic)}
                                className="card-img-top img-fluid card-image "
                                style={{ height: "100%", objectFit: "cover", cursor: "pointer" }}
                              />
                            </div>
                            <ul className="list-group list-group-flush">
                              <li className="list-group-item" style={{ fontSize: 15, fontWeight: "bold" }} >
                                <div className='row' >
                                  <div className='col-12 d-flex align-items-center' style={{ textTransform: "capitalize" }} >
                                    Vehicle reg
                                  </div>
                                </div>
                              </li>
                              <li className="list-group-item">
                                <Box sx={{ flexDirection: "column" }}   >
                                  <FileUploadField
                                    label="Vehicle reg"
                                    name="vehicle_reg"
                                    fileUrl={mobileData.vehicle_prev}
                                    fileValue={mobileData.vehicle_reg_pic}
                                    showError={mobileData.vehicle_edit}
                                    onChange={selectMobileFile}
                                  />
                                  {/* <label style={{ color: "#000" }} >Vehicle reg</label>
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      border: '1px solid #dcdcdc',
                                      borderRadius: '10px',
                                      overflow: 'hidden',
                                      width: '100%',
                                      cursor: 'pointer'
                                    }}
                                    onClick={handleClick}
                                  >
                                    <div
                                      style={{
                                        backgroundColor: '#a3cc00',
                                        padding: '12px 20px',
                                        display: 'flex',
                                        alignItems: 'center'
                                      }}
                                    >
                                      <FaCloudUploadAlt size={18} color="white" />
                                    </div>
                                    <div style={{ padding: '5px 20px' }}>
                                      <span style={{ fontSize: '16px' }}>Upload File</span>
                                    </div>
                                  </div>

                                  <Input
                                    innerRef={fileInputRef}
                                    type="file"
                                    name="vehicle_reg"
                                    onChange={(e) => selectMobileFile(e)}
                                    invalid={mobileData.vehicle_reg_edit && mobileData.vehicle_reg_pic === ""}
                                    style={{ display: 'none' }}
                                  /> */}
                                  {/* <Input invalid={mobileData.vehicle_reg_edit && mobileData.vehicle_reg_pic === ""} type="file" name="vehicle_reg" onChange={(e) => selectMobileFile(e)} /> */}
                                  {/* {mobileData.vehicle_reg_edit && mobileData.vehicle_reg_pic === "" && (
                                    <FormFeedback>Image is required</FormFeedback>
                                  )} */}
                                </Box>
                              </li>
                              <li className="list-group-item">
                                <Box sx={{ flexDirection: "column" }}   >
                                  <label style={{ color: "#000" }} >Vehicle reg expiry </label>
                                  <Input type="date" value={mobileData.vehicle_reg_expiry} onChange={(e) => {
                                    setMobileData((prev) => ({ ...prev, vehicle_reg_expiry: e.target.value, vehicle_reg_edit: true }))
                                  }} fullWidth />
                                </Box>
                              </li>
                              <li className="list-group-item">
                                <Box sx={{ flexDirection: "column" }}   >
                                  <label style={{ color: "#000" }} > Plate Number </label>
                                  <Input type="text" value={mobileData.plate_number} onChange={(e) => {
                                    setMobileData((prev) => ({ ...prev, plate_number: e.target.value, vehicle_reg_edit: true }))
                                  }} fullWidth />
                                </Box>
                              </li>
                              <li className="list-group-item">
                                <Box sx={{ flexDirection: "column" }}   >
                                  <label style={{ color: "#000" }} > Vin Number </label>
                                  <Input type="text" value={vinNumber !== "" ? vinNumber : mobileData.vin_number} onChange={(e) => {
                                    setVinNumber(e.target.value); setMobileData((prev) => ({ ...prev, vehicle_reg_edit: true, laibility_insurance_edit: true, dimond_sticker_edit: true, car_inspection_edit: true, vehicle_edit: true, vehicle_reg_edit: true, fh1Edit: true }))
                                  }} fullWidth />
                                </Box>
                              </li>
                            </ul>
                          </Card>
                        </Grid>
                        <Grid item sm={12} md={12} lg={6} width={"100%"} >
                          <Card className="h-auto h-md-100 pb-4 pb-lg-0" elevation={5}  >

                            <div className="position-relative card-image " style={{ height: window.innerWidth > 768 ? "40%" : "200px" }} >
                              <img
                                src={getPreviewSrc(mobileData.vehicle_prev, mobileData.vehicle_pic)}
                                onClick={() => handlePreviewClick(mobileData.vehicle_prev, mobileData.vehicle_pic)}
                                className="card-img-top img-fluid card-image "
                                style={{ height: "100%", objectFit: "cover", cursor: "pointer" }}
                              />
                            </div>
                            <ul className="list-group list-group-flush">
                              <li className="list-group-item" style={{ fontSize: 15, fontWeight: "bold" }} >
                                <div className='row' >
                                  <div className='col-12 d-flex align-items-center' style={{ textTransform: "capitalize" }} >
                                    Vehicle pic
                                  </div>
                                </div>
                              </li>
                              <li className="list-group-item">
                                <Box sx={{ flexDirection: "column" }}   >
                                  <FileUploadField
                                    label="Vehicle pic"
                                    name="vehicle_pic"
                                    fileUrl={mobileData.vehicle_prev}
                                    fileValue={mobileData.vehicle_pic}
                                    showError={mobileData.vehicle_edit}
                                    onChange={selectMobileFile}
                                  />
                                  {/* <label style={{ color: "#000" }} >Vehicle pic</label>
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      border: '1px solid #dcdcdc',
                                      borderRadius: '10px',
                                      overflow: 'hidden',
                                      width: '100%',
                                      cursor: 'pointer'
                                    }}
                                    onClick={handleClick}
                                  >
                                    <div
                                      style={{
                                        backgroundColor: '#a3cc00',
                                        padding: '12px 20px',
                                        display: 'flex',
                                        alignItems: 'center'
                                      }}
                                    >
                                      <FaCloudUploadAlt size={18} color="white" />
                                    </div>
                                    <div style={{ padding: '5px 20px' }}>
                                      <span style={{ fontSize: '16px' }}>Upload File</span>
                                    </div>
                                  </div>

                                  <Input
                                    innerRef={fileInputRef}
                                    type="file"
                                    name="vehicle_pic"
                                    onChange={(e) => selectMobileFile(e)}
                                    invalid={mobileData.vehicle_edit && mobileData.vehicle_pic === ""}
                                    style={{ display: 'none' }}
                                  /> */}
                                  {/* <Input invalid={mobileData.vehicle_edit && mobileData.vehicle_pic === ""} type="file" name="vehicle_pic" onChange={(e) => selectMobileFile(e)} /> */}
                                  {/* {mobileData.vehicle_edit && mobileData.vehicle_pic === "" && (
                                    <FormFeedback>Image is required</FormFeedback>
                                  )} */}
                                </Box>
                              </li>
                            </ul>
                          </Card>
                        </Grid>

                      </Grid>

                      {/* Car Data Type Radio Buttons - Only show when fields are modified */}
                      {showCarDataTypeRadio && (
                        <Box px={5} pt={3} pb={2}>
                          <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold", color: "#021b38" }}>
                            Car Data Type *
                          </Typography>
                          <Box sx={{ display: "flex", gap: 3, alignItems: "center" }}>
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                              <input
                                type="radio"
                                id="newCar-desktop"
                                name="carDataType-desktop"
                                value="new"
                                checked={carDataType === "new"}
                                onChange={(e) => setCarDataType(e.target.value)}
                                style={{
                                  marginRight: "8px",
                                  accentColor: "#97c11f",
                                  transform: "scale(1.2)"
                                }}
                              />
                              <label htmlFor="newCar-desktop" style={{ cursor: "pointer", fontWeight: "500", color: "#97c11f" }}>
                                New Car Data
                              </label>
                            </Box>
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                              <input
                                type="radio"
                                id="oldCar-desktop"
                                name="carDataType-desktop"
                                value="old"
                                checked={carDataType === "old"}
                                onChange={(e) => setCarDataType(e.target.value)}
                                style={{
                                  marginRight: "8px",
                                  accentColor: "#97c11f",
                                  transform: "scale(1.2)"
                                }}
                              />
                              <label htmlFor="oldCar-desktop" style={{ cursor: "pointer", fontWeight: "500", color: "#97c11f" }}>
                                Old Car Data
                              </label>
                            </Box>
                          </Box>
                          {!carDataType && (
                            <Typography variant="body2" sx={{ color: "red", mt: 1 }}>
                              Please select a car data type
                            </Typography>
                          )}
                          {carDataType === "new" && (
                            <Typography variant="body2" sx={{ color: "#97c11f", mt: 1, fontWeight: "500" }}>
                              ⚠️ All fields are required for new car data
                            </Typography>
                          )}
                        </Box>
                      )}



                      <Box pl={3} pt={3} >
                        <Button sx={{ backgroundColor: "#021b38", width: "40%", '&:hover': { backgroundColor: "#76a521" } }} onClick={handleMobileUpdate} fullWidth size="large" variant="contained" color="secondary">
                          {formBusy ? "Please wait...." : "Update"}
                        </Button>
                      </Box>
                    </>

                    : null}
            </CardContent>
          </form>

        </Card>
      }
      {/* <Box mx={2} >
        <Button
          variant="contained"
          color="secondary"

          onClick={hanldeMobileOpenDrawer}
          sx={{ width: "99%", p: 1, my: 0, backgroundColor: "#92c323", '&:hover': { backgroundColor: "#76a521" }, display: { xs: "block", md: "none" } }}
        >

          Update Car Information
        </Button>
      </Box> */}
    </>
  );
}
